// src/components/compare/property-compare.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      schemaName\n      messageContent\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingUILinkActionFragment on UILinkAction {\n    resource {\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n    target\n    useRelativePath\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSButtonFragment on EGDSButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    ... on UIPrimaryButton {\n      egdsElementId\n    }\n    disabled\n    primary\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSFloatingActionButtonFragment on UIPrimaryButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    egdsElementId\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSFloatingButtonFragment on UIPrimaryButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    primary\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    egdsElementId\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSCardinalLocalizedTextFragment on EGDSCardinalLocalizedText {\n    models {\n      key\n      source\n    }\n    text\n    accessibilityText\n    templates {\n      category\n      template\n    }\n    accessibilityTemplates {\n      category\n      template\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSSheetFragment on EGDSSheet {\n    closeText\n    closeAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCompareActionSheetFragment on LodgingCompareActionSheet {\n    sheet {\n      ...LodgingEGDSSheetFragment\n    }\n    compareActionPrompt\n    compareActionStatus {\n      ...LodgingEGDSCardinalLocalizedTextFragment\n    }\n    compareAction {\n      ...LodgingEGDSButtonFragment\n    }\n    maxCount\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PriceSummaryFragment on PropertyPrice {\n    displayMessages {\n      lineItems {\n        ...PriceMessageFragment\n        ...EnrichedMessageFragment\n      }\n    }\n    options {\n      leadingCaption\n      displayPrice {\n        formatted\n      }\n      disclaimer {\n        value\n      }\n      priceDisclaimer {\n        content\n        primaryButton {\n          text\n        }\n        trigger {\n          icon {\n            description\n          }\n        }\n      }\n      accessibilityLabel\n      strikeOut {\n        formatted\n      }\n      loyaltyPrice {\n        unit\n        amount {\n          formatted\n        }\n        totalStrikeOutPoints {\n          formatted\n        }\n      }\n    }\n    priceMessaging {\n      value\n      theme\n    }\n  }\n\n  fragment PriceMessageFragment on DisplayPrice {\n    __typename\n    role\n    price {\n      formatted\n      accessibilityLabel\n    }\n    disclaimer {\n      content\n      primaryUIButton {\n        accessibility\n        primary\n      }\n    }\n  }\n\n  fragment EnrichedMessageFragment on LodgingEnrichedMessage {\n    __typename\n    value\n    state\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  fragment IconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  fragment IllustrationFragment on Illustration {\n    description\n    id\n    link: url\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...IconFragment\n    }\n\n    ... on Mark {\n      ...MarkFragment\n    }\n\n    ... on Illustration {\n      ...IllustrationFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    linkSize: size\n    text\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSParagraphFragment on EGDSParagraph {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    __typename\n    text\n    theme\n    weight\n    size\n    decorative\n    accessibility\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSTextFragment on EGDSText {\n    ... on EGDSParagraph {\n      ...LodgingEGDSParagraphFragment\n    }\n    ... on EGDSStylizedText {\n      ...EGDSStylizedTextFragment\n    }\n    ... on EGDSPlainText {\n      __typename\n      text\n    }\n    ... on EGDSInlineLink {\n      ...LodgingEGDSInlineLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSHeadingFragment on EGDSHeading {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ... on Icon {\n        id\n        size\n      }\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...LodgingEGDSGraphicTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSLocalizedTextTemplateFragment on EGDSLocalizedTextTemplate {\n    __typename\n    template\n    token\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardGuestRatingFragment on LodgingCardPhrase {\n    accessibilityLabel\n    phraseParts {\n      ...EGDSIconRatingFragment\n    }\n    parts {\n      text\n      ... on EGDSStylizedText {\n        ...EGDSStylizedTextFragment\n      }\n      ... on EGDSText {\n        ...LodgingEGDSTextFragment\n      }\n    }\n  }\n\n  fragment EGDSIconRatingFragment on EGDSIconRating {\n    rating\n    icon {\n      size\n      theme\n      token\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingBadgeFragment on EGDSStandardBadge {\n    text\n    theme\n    graphic {\n      __typename\n      ... on Icon {\n        description\n        id\n      }\n      ... on Mark {\n        description\n        id\n      }\n    }\n    size\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSImageFragment on Image {\n    description\n    url\n    thumbnailClickAnalytics {\n      referrerId\n      linkName\n    }\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingMediaItemFragment on LodgingMediaItem {\n    id\n    media {\n      ... on Image {\n        ...LodgingEGDSImageFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingGalleryCarouselFragment on LodgingGalleryCarousel {\n    accessibilityHeadingText\n    navClickAnalytics {\n      referrerId\n      linkName\n    }\n    intersectionAnalytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    media {\n      ...LodgingMediaItemFragment\n    }\n    nextButtonText\n    previousButtonText\n  }\n\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AdaptexCampaignTrackingDetailFragment on AdaptexCampaignTrackingDetail {\n    campaignId\n    eventTarget\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TripsSaveItemFragment on TripsSaveItem {\n    initialChecked\n    itemId\n    source\n    attributes {\n      ...TripsSaveStayAttributesFragment\n      ...TripsSaveActivityAttributesFragment\n      ...TripsSaveFlightSearchAttributesFragment\n    }\n    save {\n      ...TripsSaveItemPropertiesFragment\n    }\n    remove {\n      ...TripsSaveItemPropertiesFragment\n    }\n  }\n\n  fragment TripsSaveStayAttributesFragment on TripsSaveStayAttributes {\n    checkInDate {\n      ...DateFragment\n    }\n    checkoutDate {\n      ...DateFragment\n    }\n    regionId\n    roomConfiguration {\n      numberOfAdults\n      childAges\n    }\n  }\n\n  fragment TripsSaveActivityAttributesFragment on TripsSaveActivityAttributes {\n    regionId\n    dateRange {\n      start {\n        ...DateFragment\n      }\n      end {\n        ...DateFragment\n      }\n    }\n  }\n\n  fragment TripsSaveItemPropertiesFragment on TripsSaveItemProperties {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    adaptexSuccessCampaignIds {\n      ...AdaptexCampaignTrackingDetailFragment\n    }\n    label\n  }\n\n  fragment TripsSaveFlightSearchAttributesFragment on TripsSaveFlightSearchAttributes {\n    searchCriteria {\n      primary {\n        journeyCriterias {\n          arrivalDate {\n            ...DateFragment\n          }\n          departureDate {\n            ...DateFragment\n          }\n          destination\n          destinationAirportLocationType\n          origin\n          originAirportLocationType\n        }\n        searchPreferences {\n          advancedFilters\n          airline\n          cabinClass\n        }\n        travelers {\n          age\n          type\n        }\n        tripType\n      }\n    }\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardSaveItemFragment on LodgingSaveItem {\n    items {\n      itemId\n    }\n    labels {\n      saveLabel\n      removeLabel\n    }\n    messages {\n      saveMessage\n      removeMessage\n    }\n    initialChecked\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardMediaSectionFragment on LodgingCardMediaSection {\n    gallery {\n      ...LodgingGalleryCarouselFragment\n    }\n    saveItem {\n      ...LodgingCardSaveItemFragment\n    }\n    saveTripItem {\n      ...TripsSaveItemFragment\n    }\n    badges {\n      primaryBadge {\n        ...LodgingBadgeFragment\n      }\n      secondaryBadge {\n        ...LodgingBadgeFragment\n      }\n      tertiaryBadge {\n        ...LodgingBadgeFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSRatingFragment on EGDSRating {\n    accessibility\n    rating\n    ... on EGDSIconRating {\n      icon {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCompareBadgeFragment on EGDSStandardBadge {\n    text\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingPriceSummaryFragment on Offer {\n    price {\n      options {\n        leadingCaption\n        displayPrice {\n          formatted\n        }\n        priceDisclaimer {\n          content\n          primaryButton {\n            text\n          }\n          trigger {\n            icon {\n              description\n            }\n          }\n        }\n        accessibilityLabel\n        strikeOut {\n          formatted\n        }\n        loyaltyPrice {\n          unit\n          amount {\n            formatted\n          }\n          totalStrikeOutPoints {\n            formatted\n          }\n        }\n      }\n      priceMessaging {\n        value\n        theme\n      }\n    }\n  }\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCompareTextItemsFragment on LodgingCompareTextItems {\n    items {\n      graphic {\n        ...UIGraphicFragment\n      }\n      text {\n        ...EGDSStylizedTextFragment\n      }\n    }\n  }\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCompareCellContentFragment on LodgingCompareCellContent {\n    __typename\n    ...LodgingEGDSRatingFragment\n    ...LodgingCardGuestRatingFragment\n    ... on LodgingCardPriceSection {\n      priceSummary {\n        ...PriceSummaryFragment\n      }\n      badge {\n        ...LodgingCompareBadgeFragment\n      }\n    }\n    ...LodgingCompareTextItemsFragment\n  }\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCompareCellFragment on LodgingCompareCell {\n    content {\n      ...LodgingCompareCellContentFragment\n    }\n  }\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCompareRemoveActionFragment on LodgingCompareRemoveAction {\n    propertyId\n    action {\n      ...LodgingEGDSButtonFragment\n    }\n  }\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCompareSectionFragment on LodgingCompareSection {\n    mediaRow {\n      ...LodgingCardMediaSectionFragment\n    }\n    compareRows {\n      cells {\n        ...LodgingCompareCellFragment\n      }\n    }\n    viewRow {\n      ...LodgingEGDSButtonFragment\n    }\n    removeRow {\n      ...LodgingCompareRemoveActionFragment\n    }\n  }\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingErrorResponseFragment on LodgingErrorResponse {\n    header\n    body\n    button {\n      ...LodgingEGDSButtonFragment\n    }\n    errorRecoveryButtons {\n      ...LodgingEGDSButtonFragment\n    }\n  }\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _taggedTemplateLiteral([
        "\n  query CompareSectionQuery(\n    $context: ContextInput!\n    $criteria: PropertySearchCriteriaInput\n    $propertyIds: [String!]\n    $shoppingContext: ShoppingContextInput\n  ) {\n    propertyCompare(context: $context) {\n      compareSection(criteria: $criteria, propertyIds: $propertyIds, shoppingContext: $shoppingContext) {\n        content {\n          ...LodgingCompareSectionFragment\n        }\n        error {\n          ...LodgingErrorResponseFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCompareDialogFragment on EGDSFullScreenDialog {\n    closeAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    toolbar {\n      closeText\n      title\n    }\n  }\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyCompareQuery($context: ContextInput!) {\n    propertyCompare(context: $context) {\n      actionSheet {\n        ...LodgingCompareActionSheetFragment\n      }\n      dialog {\n        ...LodgingCompareDialogFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _taggedTemplateLiteral([
        "\n  query CompareSelectionAdaptExQuery(\n    $context: ContextInput!\n    $criteria: PropertySearchCriteriaInput\n    $shoppingContext: ShoppingContextInput\n    $stateContext: LodgingAdaptExContextInput\n  ) {\n    propertyCompare(context: $context) {\n      compareSelectionAdaptEx(criteria: $criteria, shoppingContext: $shoppingContext, stateContext: $stateContext) {\n        campaignId\n        payloadId\n        arms {\n          name\n          level\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingProductAmenityFragment on EGDSIconText {\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
import React47 from "react";
import { gql as gql45, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
// ../internal/src/components/common/client-side-analytics/client-side-analytics.ts
import { useCallback } from "react";
import { gql } from "@apollo/client";
import { ITrackType, useClickstreamAnalytics } from "@shared-ui/clickstream-analytics-context";
var clientSideAnalyticsFragment = gql(_templateObject());
var referrerMap = {
    CLICK: "click",
    IMPRESSION: "impression"
};
var trackAnalyticsList = function(clickstreamAnalytics, analytics) {
    if (analytics) {
        var track = clickstreamAnalytics.track;
        var referrerId = analytics.referrerId, linkName = analytics.linkName, uisPrimeMessages = analytics.uisPrimeMessages;
        var _analytics_eventType;
        var eventType = referrerMap[(_analytics_eventType = analytics.eventType) !== null && _analytics_eventType !== void 0 ? _analytics_eventType : "CLICK"];
        var message = {
            schemaName: "referrer",
            messageContent: {
                referrerId: referrerId,
                linkName: linkName,
                eventType: eventType
            }
        };
        var data = !(uisPrimeMessages === null || uisPrimeMessages === void 0 ? void 0 : uisPrimeMessages.length) ? message : [
            message
        ].concat(_toConsumableArray(uisPrimeMessages.map(function(param) {
            var schemaName = param.schemaName, messageContent = param.messageContent;
            return {
                schemaName: schemaName,
                messageContent: JSON.parse(messageContent)
            };
        })));
        track(ITrackType.EVENT, {
            data: data
        });
    }
};
var useTrackClientSideAnalytics = function(analytics) {
    var clickstreamAnalytics = useClickstreamAnalytics();
    return useCallback(function() {
        if (analytics) {
            trackAnalyticsList(clickstreamAnalytics, analytics);
        }
    }, [
        analytics,
        clickstreamAnalytics
    ]);
};
// ../internal/src/components/lodging-egds-button/lodging-egds-button.tsx
import React2 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton } from "uitk-react-button";
// ../internal/src/components/lodging-egds-icon/lodging-egds-icon.tsx
import React from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var fragment = gql2(_templateObject1());
var LodgingEGDSIcon = function(param) {
    var ariaHidden = param.ariaHidden, data = param.data;
    var description = data.description, id = data.id, size = data.size, theme = data.theme;
    var _ref;
    return /* @__PURE__ */ React.createElement(UitkIcon, {
        description: ariaHidden ? void 0 : description,
        title: ariaHidden ? void 0 : description,
        id: id,
        name: id,
        size: (_ref = size && UitkIconSize[size]) !== null && _ref !== void 0 ? _ref : void 0,
        theme: theme !== null && theme !== void 0 ? theme : void 0
    });
};
LodgingEGDSIcon.fragment = fragment;
LodgingEGDSIcon.displayName = "LodgingEGDSIcon";
// ../internal/src/components/lodging-ui-link-action/lodging-ui-link-action.ts
import { gql as gql3 } from "@apollo/client";
var _obj;
// ../internal/src/components/uitk-link-target-mapper.tsx
var UILinkTargetMap = (_obj = {}, _defineProperty(_obj, "EXTERNAL" /* EXTERNAL */ , "_blank"), _defineProperty(_obj, "INTERNAL" /* INTERNAL */ , "_self"), _obj);
// ../internal/src/components/lodging-ui-link-action/lodging-ui-link-action.ts
var fragment2 = gql3(_templateObject2());
var getLodgingUILinkActionPath = function(action) {
    if (action.resource.__typename !== "HttpURI") {
        return null;
    }
    return action.useRelativePath ? action.resource.relativePath : action.resource.value;
};
var getLodgingUILinkActionTarget = function(action) {
    return UILinkTargetMap[action.target];
};
// ../internal/src/components/lodging-egds-button/lodging-egds-button.tsx
var fragment3 = gql4(_templateObject3(), clientSideAnalyticsFragment, fragment2, LodgingEGDSIcon.fragment);
var deriveLinkProps = function(action) {
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var buttonComponents = {
    UIPrimaryButton: UitkPrimaryButton,
    UISecondaryButton: UitkSecondaryButton,
    UITertiaryButton: UitkTertiaryButton
};
var LodgingEGDSButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, __typename = _param_data.__typename, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, primary = _param_data.primary, action = _param_data.action, icon = _param_data.icon, dataStid = _param.dataStid, props = _objectWithoutProperties(_param, [
        "onClick",
        "data",
        "dataStid"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps(action);
    var handleClick = React2.useCallback(function(event) {
        trackClick();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _objectSpread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    var Button = buttonComponents[__typename];
    if (Button) {
        return /* @__PURE__ */ React2.createElement(Button, _objectSpreadProps(_objectSpread({}, buttonProps), {
            "data-stid": dataStid
        }), icon ? /* @__PURE__ */ React2.createElement(LodgingEGDSIcon, {
            data: icon
        }) : null, primary);
    }
    return null;
};
LodgingEGDSButton.fragment = fragment3;
LodgingEGDSButton.displayName = "EGDSButton";
// ../internal/src/components/lodging-egds-button/lodging-egds-floating-action-button.tsx
import React3 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkFloatingActionButton } from "uitk-react-button";
var fragment4 = gql5(_templateObject4());
var deriveLinkProps2 = function(action) {
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var LodgingEGDSFloatingActionButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, action = _param_data.action, icon = _param_data.icon, props = _objectWithoutProperties(_param, [
        "onClick",
        "data"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps2(action);
    var handleClick = React3.useCallback(function(event) {
        trackClick();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _objectSpread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    return icon ? /* @__PURE__ */ React3.createElement(UitkFloatingActionButton, _objectSpread({}, buttonProps), /* @__PURE__ */ React3.createElement(LodgingEGDSIcon, {
        data: icon
    })) : null;
};
LodgingEGDSFloatingActionButton.fragment = fragment4;
LodgingEGDSFloatingActionButton.displayName = "EGDSFloatingActionButton";
// ../internal/src/components/lodging-egds-button/lodging-egds-floating-button.tsx
import React4 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkFloatingButton } from "uitk-react-button";
var fragment5 = gql6(_templateObject5());
var deriveLinkProps3 = function(action) {
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var LodgingEGDSFloatingButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, primary = _param_data.primary, action = _param_data.action, icon = _param_data.icon, props = _objectWithoutProperties(_param, [
        "onClick",
        "data"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps3(action);
    var handleClick = React4.useCallback(function(event) {
        trackClick();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _objectSpread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    return /* @__PURE__ */ React4.createElement(UitkFloatingButton, _objectSpread({}, buttonProps), icon ? /* @__PURE__ */ React4.createElement(LodgingEGDSIcon, {
        data: icon
    }) : null, primary);
};
LodgingEGDSFloatingButton.fragment = fragment5;
LodgingEGDSFloatingButton.displayName = "EGDSFloatingButton";
// ../internal/src/components/lodging-egds-cardinal-localized-text/lodging-egds-cardinal-localized-text.tsx
import React5, { useMemo } from "react";
import { gql as gql7 } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
var fragment6 = gql7(_templateObject6());
var interpolate = function(template, models, replacements, locale) {
    return models.reduce(function(accumulator, param) {
        var key = param.key;
        var _replacements_get;
        var replacementValue = (_replacements_get = replacements.get(key)) !== null && _replacements_get !== void 0 ? _replacements_get : "";
        var replacement = typeof replacementValue === "number" ? new Intl.NumberFormat(locale).format(replacementValue) : replacementValue;
        return accumulator.replaceAll("${".concat(key, "}"), replacement);
    }, template.template);
};
var LodgingEGDSCardinalLocalizedText = function(param) {
    var data = param.data, values = param.values, tmp = param.tag, Tag = tmp === void 0 ? "span" : tmp;
    var context = useBexApi().context;
    var locale = context.locale.replace("_", "-");
    return useMemo(function() {
        var _data_accessibilityTemplates;
        var replacements = new Map(data.models.map(function(param) {
            var key = param.key, source = param.source;
            return [
                key,
                values[source]
            ];
        }));
        var amount = replacements.get(data.models[0].key);
        var pluralCategory = new Intl.PluralRules(locale).select(Number(amount)).toUpperCase();
        var predicate = function(param) {
            var category = param.category;
            return category === pluralCategory;
        };
        var template = data.templates.find(predicate);
        var accessibilityTemplate = (_data_accessibilityTemplates = data.accessibilityTemplates) === null || _data_accessibilityTemplates === void 0 ? void 0 : _data_accessibilityTemplates.find(predicate);
        var text = template && interpolate(template, data.models, replacements, locale);
        var accessibilityText = accessibilityTemplate && interpolate(accessibilityTemplate, data.models, replacements, locale);
        var _ref;
        return /* @__PURE__ */ React5.createElement(Tag, {
            "aria-label": (_ref = accessibilityText !== null && accessibilityText !== void 0 ? accessibilityText : data.accessibilityText) !== null && _ref !== void 0 ? _ref : void 0
        }, text !== null && text !== void 0 ? text : data.text);
    }, [
        data,
        values,
        Tag,
        locale
    ]);
};
LodgingEGDSCardinalLocalizedText.fragment = fragment6;
LodgingEGDSCardinalLocalizedText.displayName = "LodgingEGDSCardinalLocalizedText";
// ../internal/src/components/lodging-egds-sheet/lodging-egds-sheet.tsx
import React6, { useCallback as useCallback2 } from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkSheet } from "uitk-react-sheet";
var fragment7 = gql8(_templateObject7());
var LodgingEGDSSheet = function(_param) {
    var data = _param.data, closeCallback = _param.closeCallback, props = _objectWithoutProperties(_param, [
        "data",
        "closeCallback"
    ]);
    var trackClose = useTrackClientSideAnalytics(data.closeAnalytics);
    var handleClose = useCallback2(function() {
        trackClose();
        closeCallback === null || closeCallback === void 0 ? void 0 : closeCallback();
    }, [
        trackClose,
        closeCallback
    ]);
    var sheetProps = _objectSpread({
        closeCallback: handleClose
    }, props);
    return /* @__PURE__ */ React6.createElement(UitkSheet, _objectSpread({}, sheetProps));
};
LodgingEGDSSheet.displayName = "LodgingEGDSSheet";
LodgingEGDSSheet.fragment = fragment7;
// src/components/compare/__private/__fragments/lodging-compare-action-sheet.tsx
import React7, { useCallback as useCallback3, useMemo as useMemo2 } from "react";
import { gql as gql9 } from "@apollo/client";
// ../internal/src/components/lodging-compare/lodging-compare-state.tsx
var STATE_FIELD_NAME = "lodgingCompare";
var COMPARE_PROPERTY_IDS_QUERY_PARAMETER = "comparePropertyIds";
var MAX_SELECTABLE = 5;
var defaultState = {
    searchResultsProperties: [],
    comparePropertyIds: [],
    isDialogOpen: false
};
var SET_PROPERTIES = "".concat(STATE_FIELD_NAME, ".setProperties");
var ADD_COMPARE_PROPERTY = "".concat(STATE_FIELD_NAME, ".addCompareProperty");
var REMOVE_COMPARE_PROPERTY = "".concat(STATE_FIELD_NAME, ".removeCompareProperty");
var OPEN_DIALOG = "".concat(STATE_FIELD_NAME, ".openDialog");
var CLOSE_DIALOG = "".concat(STATE_FIELD_NAME, ".closeDialog");
var events = [
    SET_PROPERTIES,
    ADD_COMPARE_PROPERTY,
    REMOVE_COMPARE_PROPERTY,
    OPEN_DIALOG,
    CLOSE_DIALOG
];
// ../internal/src/components/lodging-compare/utilities.ts
var getPropertyIdFromCardId = function(cardId) {
    return cardId.split("-")[0];
};
// src/components/compare/__private/__fragments/lodging-compare-action-sheet.tsx
import { useProvidedState } from "@shared-ui/provided-state-context";
import { UitkButtonSize } from "uitk-react-button";
import { UitkCard } from "uitk-react-cards";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSheetContent } from "uitk-react-sheet";
import { UitkText } from "uitk-react-text";
var fragment8 = gql9(_templateObject8());
var LodgingCompareActionSheet = function(param) {
    var data = param.data;
    var _useProvidedState = _slicedToArray(useProvidedState(), 2), state = _useProvidedState[0], dispatch = _useProvidedState[1];
    var _state_STATE_FIELD_NAME;
    var comparePropertyIds = ((_state_STATE_FIELD_NAME = state[STATE_FIELD_NAME]) !== null && _state_STATE_FIELD_NAME !== void 0 ? _state_STATE_FIELD_NAME : defaultState).comparePropertyIds;
    var triggerRef = React7.useRef();
    var uniquePropertyIds = _toConsumableArray(new Set(comparePropertyIds.map(getPropertyIdFromCardId)));
    var handleClick = useCallback3(function() {
        dispatch({
            type: OPEN_DIALOG
        });
    }, [
        dispatch
    ]);
    var values = useMemo2(function() {
        return {
            properties: uniquePropertyIds.length
        };
    }, [
        uniquePropertyIds.length
    ]);
    if (!data.sheet) {
        return null;
    }
    var sheet = data.sheet, compareActionPrompt = data.compareActionPrompt, compareActionStatus = data.compareActionStatus, compareAction = data.compareAction;
    return /* @__PURE__ */ React7.createElement(LodgingEGDSSheet, {
        data: sheet,
        isVisible: uniquePropertyIds.length > 0,
        type: "bottom",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React7.createElement(UitkSheetContent, null, /* @__PURE__ */ React7.createElement(UitkLayoutGrid, {
        alignItems: "center",
        columns: {
            medium: [
                "1fr",
                "min-content"
            ]
        },
        space: {
            row: "four",
            column: "six"
        }
    }, /* @__PURE__ */ React7.createElement(UitkLayoutGridItem, null, uniquePropertyIds.length === 1 ? /* @__PURE__ */ React7.createElement(UitkCard, {
        border: true,
        padded: true
    }, /* @__PURE__ */ React7.createElement(UitkLayoutFlex, {
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React7.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(UitkIcon2, {
        name: "info_outline",
        spotlight: "info"
    }))), /* @__PURE__ */ React7.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React7.createElement(UitkText, {
        size: 400
    }, compareActionPrompt)))) : compareActionStatus && /* @__PURE__ */ React7.createElement(UitkText, {
        size: 400
    }, /* @__PURE__ */ React7.createElement(LodgingEGDSCardinalLocalizedText, {
        data: compareActionStatus,
        values: values
    }))), /* @__PURE__ */ React7.createElement(UitkLayoutGridItem, null, compareAction && /* @__PURE__ */ React7.createElement(LodgingEGDSButton, {
        data: compareAction,
        disabled: uniquePropertyIds.length < 2,
        onClick: handleClick,
        isFullWidth: true,
        size: UitkButtonSize.LARGE
    })))));
};
LodgingCompareActionSheet.fragment = fragment8;
LodgingCompareActionSheet.displayName = "LodgingCompareActionSheet";
// src/components/compare/__private/__fragments/lodging-compare-dialog.tsx
import React46, { useCallback as useCallback6, useEffect, useRef } from "react";
import { gql as gql44 } from "@apollo/client";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { useProvidedState as useProvidedState7 } from "@shared-ui/provided-state-context";
import { UitkSheet as UitkSheet2, UitkSheetContent as UitkSheetContent2 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkToolbar } from "uitk-react-toolbar";
// src/components/compare/__private/__fragments/compare-section.tsx
import React45, { useMemo as useMemo5 } from "react";
import { gql as gql43, useQuery } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// ../internal/src/components/common/pricing-fragments.ts
import { gql as gql10 } from "@apollo/client";
var PriceSummaryFragment = gql10(_templateObject9());
// ../internal/src/components/common/ui-graphic.tsx
import React11 from "react";
import { gql as gql14 } from "@apollo/client";
// ../internal/src/components/common/icon.tsx
import React8 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
var fragment9 = gql11(_templateObject10());
var _data_title, _data_theme;
var Icon = function(param) {
    var className = param.className, data = param.data, spotlight = param.spotlight;
    return /* @__PURE__ */ React8.createElement(UitkIcon3, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: data.size ? UitkIconSize2[data.size] : void 0,
        title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
        theme: (_data_theme = data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
        shadow: Boolean(data.withBackground),
        spotlight: spotlight !== null && spotlight !== void 0 ? spotlight : void 0
    });
};
Icon.displayName = "UitkIcon";
Icon.fragment = fragment9;
// ../internal/src/components/common/illustration.tsx
import React9 from "react";
import { gql as gql12 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var fragment10 = gql12(_templateObject11());
var Illustration = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React9.createElement(UitkIllustrations, {
        alt: data.description,
        url: data.link
    });
};
Illustration.displayName = "Illustration";
Illustration.fragment = fragment10;
// ../internal/src/components/common/mark.tsx
import React10 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var fragment11 = gql13(_templateObject12());
var Mark = function(param) {
    var className = param.className, markSize = param.markSize, data = param.data;
    var _data_url;
    /* @__PURE__ */ return React10.createElement(UitkMark, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: markSize !== null && markSize !== void 0 ? markSize : data.markSize ? UitkMarkSize[data.markSize] : void 0,
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
    });
};
Mark.displayName = "Mark";
Mark.fragment = fragment11;
// ../internal/src/components/common/ui-graphic.tsx
var __UIGraphicFragment = gql14(_templateObject13(), Icon.fragment, Mark.fragment, Illustration.fragment);
var UiGraphic = function(param) {
    var className = param.className, markSize = param.markSize, data = param.data;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React11.createElement(Icon, {
                className: className,
                data: data
            });
        case "Mark":
            return /* @__PURE__ */ React11.createElement(Mark, {
                className: className,
                data: data,
                markSize: markSize
            });
        case "Illustration":
            return /* @__PURE__ */ React11.createElement(Illustration, {
                data: data
            });
        default:
            return null;
    }
};
UiGraphic.displayName = "UiGraphic";
UiGraphic.fragment = __UIGraphicFragment;
// ../internal/src/components/lodging-card/__private/lodging-card-guest-rating.tsx
import React22 from "react";
import { gql as gql25 } from "@apollo/client";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize4 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
// ../internal/src/components/lodging-egds-text/lodging-egds-text.tsx
import React15 from "react";
import { gql as gql18 } from "@apollo/client";
import { UitkText as UitkText3 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-text/lodging-egds-inline-link.tsx
import React12 from "react";
import { gql as gql15 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
var _obj1;
// ../internal/src/components/__private/link-map.ts
var linkSizeMapper = (_obj1 = {}, _defineProperty(_obj1, "SMALL" /* SMALL */ , "small"), _defineProperty(_obj1, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj1, "LARGE" /* LARGE */ , "large"), _obj1);
var _obj2;
var UILinkTargetMap2 = (_obj2 = {}, _defineProperty(_obj2, "EXTERNAL" /* EXTERNAL */ , "_blank"), _defineProperty(_obj2, "INTERNAL" /* INTERNAL */ , "_self"), _obj2);
// ../internal/src/components/lodging-egds-text/lodging-egds-inline-link.tsx
var fragment12 = gql15(_templateObject14());
var LodgingEGDSInlineLink = function(param) {
    var className = param.className, _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, disabled = _param_data.disabled, linkSize = _param_data.linkSize, text = _param_data.text;
    var clickTracker = useClickTracker();
    var onClick = React12.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React12.createElement(UitkLink, {
        className: className,
        size: linkSizeMapper[linkSize],
        onClickCapture: onClick,
        disabled: disabled,
        inline: true
    }, /* @__PURE__ */ React12.createElement("a", {
        href: resource.value,
        target: UILinkTargetMap2[target]
    }, text, accessibility && /* @__PURE__ */ React12.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility)));
};
LodgingEGDSInlineLink.fragment = fragment12;
LodgingEGDSInlineLink.displayName = "LodgingEGDSInlineLink";
// ../internal/src/components/lodging-egds-text/lodging-egds-paragraph.tsx
import React13 from "react";
import { gql as gql16 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
var fragment13 = gql16(_templateObject15());
var LodgingEGDSParagraph = function(param) {
    var data = param.data, _param_size = param.size, size = _param_size === void 0 ? 2 : _param_size;
    return /* @__PURE__ */ React13.createElement(UitkParagraph, {
        size: size
    }, data.text);
};
LodgingEGDSParagraph.fragment = fragment13;
LodgingEGDSParagraph.displayName = "LodgingEGDSParagraph";
// ../internal/src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
import React14 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
var _obj3;
// ../internal/src/components/lodging-egds-text/__private/text-theme.ts
var textThemeMapper = (_obj3 = {}, _defineProperty(_obj3, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _defineProperty(_obj3, "LOYALTY" /* LOYALTY */ , "loyalty"), _defineProperty(_obj3, "NEGATIVE" /* NEGATIVE */ , "negative"), _defineProperty(_obj3, "POSITIVE" /* POSITIVE */ , "positive"), _defineProperty(_obj3, "PRIMARY" /* PRIMARY */ , "emphasis"), _defineProperty(_obj3, "SECONDARY" /* SECONDARY */ , "default"), _defineProperty(_obj3, "INVERSE" /* INVERSE */ , "inverse"), _obj3);
var _obj4;
// ../internal/src/components/lodging-egds-text/__private/text-weight.ts
var textWeightMapper = (_obj4 = {}, _defineProperty(_obj4, "BOLD" /* BOLD */ , "bold"), _defineProperty(_obj4, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj4, "REGULAR" /* REGULAR */ , "regular"), _obj4);
// ../internal/src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
var fragment14 = gql17(_templateObject16());
var sizeMap = {
    "100": 100,
    "200": 200,
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800,
    "900": 900
};
var decorativeMap = {
    LINE_THROUGH: "s",
    SUBSCRIPT: "sub",
    SUPERSCRIPT: "sup",
    UNDERLINE: "u"
};
var EGDSStylizedText = function(_param) {
    var data = _param.data, theme = _param.theme, weight = _param.weight, size = _param.size, props = _objectWithoutProperties(_param, [
        "data",
        "theme",
        "weight",
        "size"
    ]);
    var decorative = data.decorative, accessibility = data.accessibility;
    var textProps = _objectSpread({
        theme: data.theme ? textThemeMapper[data.theme] : theme,
        weight: data.weight ? textWeightMapper[data.weight] : weight,
        size: data.size ? sizeMap[data.size] : size
    }, props);
    var Decorative = decorative && decorativeMap[decorative];
    var content = Decorative ? /* @__PURE__ */ React14.createElement(Decorative, null, data.text) : data.text;
    return /* @__PURE__ */ React14.createElement(UitkText2, _objectSpread({}, textProps), content, accessibility && /* @__PURE__ */ React14.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility));
};
EGDSStylizedText.fragment = fragment14;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/lodging-egds-text/lodging-egds-text.tsx
var fragment15 = gql18(_templateObject17(), LodgingEGDSParagraph.fragment, EGDSStylizedText.fragment, LodgingEGDSInlineLink.fragment);
var LodgingEGDSText = function(param) {
    var size = param.size, overflow = param.overflow, spacing = param.spacing, data = param.data, align = param.align, inline = param.inline, className = param.className;
    switch(data.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React15.createElement(UitkText3, {
                inline: inline,
                size: size
            }, data.text);
        case "EGDSParagraph":
            return /* @__PURE__ */ React15.createElement(LodgingEGDSParagraph, {
                data: data
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React15.createElement(EGDSStylizedText, {
                size: size,
                overflow: overflow,
                spacing: spacing,
                data: data,
                align: align,
                inline: inline
            });
        case "EGDSInlineLink":
            return /* @__PURE__ */ React15.createElement(LodgingEGDSInlineLink, {
                className: className,
                data: data
            });
        default:
            return null;
    }
};
LodgingEGDSText.fragment = fragment15;
LodgingEGDSText.displayName = "LodgingEGDSText";
// ../internal/src/components/lodging-egds-text/lodging-egds-heading.tsx
import React16 from "react";
import { gql as gql19 } from "@apollo/client";
import { UitkHeading } from "uitk-react-text";
var fragment16 = gql19(_templateObject18());
var LodgingEGDSHeading = function(param) {
    var tag = param.tag, size = param.size, data = param.data;
    return /* @__PURE__ */ React16.createElement(UitkHeading, {
        tag: tag,
        size: size
    }, data.text);
};
LodgingEGDSHeading.fragment = fragment16;
LodgingEGDSHeading.displayName = "LodgingEGDSHeading";
// ../internal/src/components/lodging-egds-text/egds-spannable-text.tsx
import React20 from "react";
import { gql as gql23 } from "@apollo/client";
import { UitkText as UitkText6 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-text/egds-spannable-text-content.tsx
import React19 from "react";
import { gql as gql22 } from "@apollo/client";
// ../internal/src/components/lodging-egds-graphic-text/lodging-egds-graphic-text.tsx
import React17 from "react";
import { gql as gql20 } from "@apollo/client";
import { UitkIcon as UitkIcon4, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText as UitkText4 } from "uitk-react-text";
var fragment17 = gql20(_templateObject19());
var LodgingEGDSGraphicText = function(param) {
    var data = param.data, textProps = param.textProps, customTextSize = param.customTextSize;
    var text = data.text, graphic = data.graphic;
    return /* @__PURE__ */ React17.createElement("div", null, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && graphic.id && /* @__PURE__ */ React17.createElement(UitkSpacing, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React17.createElement(UitkIcon4, {
        name: graphic.id,
        size: graphic.size ? UitkIconSize3[graphic.size] : UitkIconSize3.EXTRA_SMALL
    })), /* @__PURE__ */ React17.createElement(UitkText4, _objectSpreadProps(_objectSpread({
        size: customTextSize || 200
    }, textProps), {
        inline: !!graphic
    }), text));
};
LodgingEGDSGraphicText.fragment = fragment17;
LodgingEGDSGraphicText.displayName = "LodgingEGDSGraphicText";
// ../internal/src/components/lodging-egds-text/lodging-egds-plain-text.tsx
import React18 from "react";
import { gql as gql21 } from "@apollo/client";
import { UitkText as UitkText5 } from "uitk-react-text";
var fragment18 = gql21(_templateObject20());
var EGDSPlainText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, align = param.align, data = param.data;
    var text = data.text;
    return /* @__PURE__ */ React18.createElement(UitkText5, {
        className: className,
        inline: inline,
        size: size,
        align: align
    }, text);
};
EGDSPlainText.fragment = fragment18;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/lodging-egds-text/egds-spannable-text-content.tsx
var fragment19 = gql22(_templateObject21(), EGDSStylizedText.fragment, EGDSPlainText.fragment, LodgingEGDSGraphicText.fragment);
var EGDSSpannableTextContent = function(param) {
    var className = param.className, size = param.size, data = param.data;
    switch(data.__typename){
        case "EGDSStylizedText":
            return /* @__PURE__ */ React19.createElement(EGDSStylizedText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React19.createElement(EGDSPlainText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React19.createElement(LodgingEGDSGraphicText, {
                data: data
            });
        default:
            return null;
    }
};
EGDSSpannableTextContent.fragment = fragment19;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/lodging-egds-text/egds-spannable-text.tsx
var fragment20 = gql23(_templateObject22(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function(props) {
    var _data_contents, _data_inlineContent, _data_inlineContent1;
    var align = props.align, data = props.data, styleProps = _objectWithoutProperties(props, [
        "align",
        "data"
    ]);
    if ((data === null || data === void 0 ? void 0 : (_data_contents = data.contents) === null || _data_contents === void 0 ? void 0 : _data_contents.length) === 0 && !(data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length)) {
        return /* @__PURE__ */ React20.createElement(UitkText6, _objectSpreadProps(_objectSpread({}, styleProps), {
            inline: true,
            align: align
        }), data.text);
    }
    if (data === null || data === void 0 ? void 0 : (_data_inlineContent1 = data.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.length) {
        return /* @__PURE__ */ React20.createElement(React20.Fragment, null, data.inlineContent.map(function(item, index) {
            return /* @__PURE__ */ React20.createElement(React20.Fragment, null, /* @__PURE__ */ React20.createElement(EGDSSpannableTextContent, _objectSpreadProps(_objectSpread({
                data: item
            }, styleProps), {
                key: "spannable-item-".concat(index)
            })));
        }));
    }
    return /* @__PURE__ */ React20.createElement(React20.Fragment, null, data.contents.map(function(item, index) {
        return /* @__PURE__ */ React20.createElement(React20.Fragment, {
            key: "spannable-item-".concat(index)
        }, /* @__PURE__ */ React20.createElement(EGDSSpannableTextContent, _objectSpread({
            data: item
        }, styleProps)));
    }));
};
EGDSSpannableText.fragment = fragment20;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/lodging-egds-text/lodging-egds-localized-text-template.tsx
import React21 from "react";
import { gql as gql24 } from "@apollo/client";
var fragment21 = gql24(_templateObject23());
var LodgingEGDSLocalizedTextTemplate = function(param) {
    var data = param.data, value = param.value;
    return /* @__PURE__ */ React21.createElement(React21.Fragment, null, data.template.replace("{".concat(data.token, "}"), value));
};
LodgingEGDSLocalizedTextTemplate.fragment = fragment21;
LodgingEGDSLocalizedTextTemplate.displayName = "LodgingEGDSLocalizedTextTemplate";
// ../internal/src/components/lodging-card/__private/lodging-card-guest-rating.tsx
var fragment22 = gql25(_templateObject24(), LodgingEGDSText.fragment, EGDSStylizedText.fragment);
var GuestReviewRating = function(param) {
    var part = param.part, index = param.index, isReview = param.isReview, size = param.size;
    return /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem2, null, isReview ? /* @__PURE__ */ React22.createElement(UitkSpacing2, {
        margin: index === 1 ? {
            inlineend: "two"
        } : {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React22.createElement("span", null, /* @__PURE__ */ React22.createElement(LodgingEGDSText, {
        data: part,
        inline: true,
        size: size
    }))) : /* @__PURE__ */ React22.createElement(UitkSpacing2, {
        padding: index === 0 ? {
            inlineend: "half"
        } : {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React22.createElement("span", null, /* @__PURE__ */ React22.createElement(LodgingEGDSText, {
        data: part,
        inline: true,
        size: size
    }))));
};
var LodgingCardGuestRating = function(param) {
    var data = param.data, size = param.size, isReview = param.isReview;
    var parts = data.parts, accessibilityLabel = data.accessibilityLabel, phraseParts = data.phraseParts;
    var ratingPart = phraseParts === null || phraseParts === void 0 ? void 0 : phraseParts.find(function(part) {
        return part.__typename === "EGDSIconRating";
    });
    return /* @__PURE__ */ React22.createElement(UitkLayoutFlex2, {
        alignItems: "start"
    }, ratingPart && /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem2, {
        alignSelf: "center"
    }, /* @__PURE__ */ React22.createElement(UitkIcon5, {
        name: ratingPart.icon.token || "star",
        theme: ratingPart.icon.theme || "default",
        size: ratingPart.icon.size ? UitkIconSize4[ratingPart.icon.size] : UitkIconSize4.EXTRA_SMALL
    })), /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React22.createElement("div", {
        "aria-hidden": !!accessibilityLabel
    }, /* @__PURE__ */ React22.createElement(UitkLayoutFlex2, {
        wrap: "wrap"
    }, parts.map(function(part, index) {
        return /* @__PURE__ */ React22.createElement(GuestReviewRating, {
            key: "guest-rate-".concat(index),
            part: part,
            index: index,
            isReview: isReview,
            size: size
        });
    })))), accessibilityLabel && /* @__PURE__ */ React22.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel));
};
LodgingCardGuestRating.fragment = fragment22;
LodgingCardGuestRating.displayName = "LodgingCardGuestRating";
// ../internal/src/components/lodging-card/__private/lodging-card-media-section.tsx
import React30 from "react";
import { gql as gql33 } from "@apollo/client";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkFigure as UitkFigure3, UitkImage as UitkImage3 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex3 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
// ../internal/src/components/lodging-card/lodging-card-utils.ts
import { ITrackType as ITrackType2 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/utils/analytics.ts
var lightweightAdaptExMicroMessage = function(param) {
    var campaignId = param.campaignId, payloadId = param.payloadId, eventType = param.eventType, eventTarget = param.eventTarget, _param_banditDisplayed = param.banditDisplayed, banditDisplayed = _param_banditDisplayed === void 0 ? true : _param_banditDisplayed;
    return {
        schemaName: "multiArmedBandit",
        messageContent: {
            campaignId: campaignId,
            events: [
                {
                    payloadId: payloadId,
                    eventType: eventType,
                    eventTarget: eventTarget,
                    banditDisplayed: banditDisplayed
                }
            ]
        }
    };
};
var createAdaptExMicroMessage = function(campaignId, events2) {
    var allEvents = events2 === null || events2 === void 0 ? void 0 : events2.reduce(function(acc, curr) {
        return _toConsumableArray(acc).concat([
            {
                payloadId: curr.payloadId,
                eventType: curr.eventType,
                eventTarget: curr.eventTarget,
                banditDisplayed: curr.banditDisplayed
            }
        ]);
    }, []);
    return {
        schemaName: "multiArmedBandit",
        messageContent: {
            campaignId: campaignId,
            events: allEvents
        }
    };
};
var adaptToAdaptExSuccessEventSchema = function(lodgingAdaptExAnalyticsEvent) {
    var mappedMessages = [];
    var campaignId = lodgingAdaptExAnalyticsEvent.campaignId, events2 = lodgingAdaptExAnalyticsEvent.events, clientSideAnalytics = lodgingAdaptExAnalyticsEvent.clientSideAnalytics;
    if (clientSideAnalytics) {
        var referrerId = clientSideAnalytics.referrerId, eventType = clientSideAnalytics.eventType, linkName = clientSideAnalytics.linkName;
        mappedMessages.push({
            messageContent: {
                referrerId: referrerId,
                eventType: (eventType === null || eventType === void 0 ? void 0 : eventType.toLowerCase()) || "click",
                linkName: linkName
            },
            schemaName: "referrer"
        });
    }
    if (events2) {
        mappedMessages.push(createAdaptExMicroMessage(campaignId, events2));
    }
    return mappedMessages;
};
// ../internal/src/components/lodging-card/lodging-card-utils.ts
var isCompactView = function(view) {
    return view === "COMPACT" /* COMPACT */ ;
};
var isCompactHorizontalView = function(view) {
    return view === "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */ ;
};
function sendProductSchemaTracking(analytics, track) {
    var _analytics_uisPrimeMessages;
    var productSchema = ((_analytics_uisPrimeMessages = analytics.uisPrimeMessages) === null || _analytics_uisPrimeMessages === void 0 ? void 0 : _analytics_uisPrimeMessages.length) > 0 ? analytics.uisPrimeMessages.map(function(param) {
        var schemaName = param.schemaName, messageContent = param.messageContent;
        return {
            schemaName: schemaName,
            messageContent: JSON.parse(messageContent)
        };
    }) : void 0;
    track(analytics.referrerId, analytics.linkName, true, productSchema);
}
var isAd = function(mediaSection) {
    var _mediaSection_badges, _mediaSection_badges_secondaryBadge;
    return ((_mediaSection_badges = mediaSection.badges) === null || _mediaSection_badges === void 0 ? void 0 : (_mediaSection_badges_secondaryBadge = _mediaSection_badges.secondaryBadge) === null || _mediaSection_badges_secondaryBadge === void 0 ? void 0 : _mediaSection_badges_secondaryBadge.theme) === "promoted";
};
// ../internal/src/components/lodging-badge/lodging-badge.tsx
import React23 from "react";
import { gql as gql26 } from "@apollo/client";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { UitkBadge, UitkBadgeLoyalty, UitkBadgeStandard, UitkBadgeStandardThemes } from "uitk-react-badge";
import { UitkIcon as UitkIcon6, UitkIconSize as UitkIconSize5 } from "uitk-react-icons";
import { UitkMark as UitkMark2, UitkMarkSize as UitkMarkSize2 } from "uitk-react-mark";
// ../internal/src/components/uitk-badge-size-mapper.tsx
import { UitkBadgeSize } from "uitk-react-badge";
var _obj5;
var UitkBadgeSizeMapper = (_obj5 = {}, _defineProperty(_obj5, UitkBadgeSize.SMALL, "small"), _defineProperty(_obj5, UitkBadgeSize.LARGE, "large"), _obj5);
// ../internal/src/components/uitk-badge-theme-mapper.tsx
import { UitkBadgeLoyaltyThemes, UitkBadgeTheme } from "uitk-react-badge";
var LOYALTY_EXTRA_HIGH_TIER = "loyalty-extra-high-tier";
var _obj6;
var UitkBadgeThemeMapper = (_obj6 = {}, _defineProperty(_obj6, UitkBadgeTheme.DEAL_BUNDLED, "deal-bundled"), _defineProperty(_obj6, UitkBadgeTheme.DEAL_GENERIC, "deal-generic"), _defineProperty(_obj6, UitkBadgeTheme.DEAL_MEMBER, "deal-member"), _defineProperty(_obj6, UitkBadgeTheme.NOTIFICATION_1, "notification-1"), _defineProperty(_obj6, UitkBadgeTheme.NOTIFICATION_2, "notification-2"), _defineProperty(_obj6, UitkBadgeTheme.VIP, "vip"), _defineProperty(_obj6, UitkBadgeTheme.LOYALTY_HIGH_TIER, "loyalty-high-tier"), _defineProperty(_obj6, UitkBadgeTheme.LOYALTY_MIDDLE_TIER, "loyalty-middle-tier"), _defineProperty(_obj6, UitkBadgeTheme.LOYALTY_LOW_TIER, "loyalty-low-tier"), _defineProperty(_obj6, UitkBadgeTheme.SPONSORED, "sponsored"), _defineProperty(_obj6, UitkBadgeTheme.VIEWED, "viewed"), _defineProperty(_obj6, UitkBadgeTheme.SAVED, "saved"), _defineProperty(_obj6, UitkBadgeTheme.FAMILY_FRIENDLY, "family-friendly"), _defineProperty(_obj6, UitkBadgeTheme.SUPPLIER_PROMO, "supplier-promo"), _defineProperty(_obj6, UitkBadgeTheme.PROMOTED, "promoted"), _obj6);
var _obj7;
var UitkBadgeLoyaltyThemeMapper = (_obj7 = {}, _defineProperty(_obj7, LOYALTY_EXTRA_HIGH_TIER, UitkBadgeLoyaltyThemes.EXTRAHIGH), _defineProperty(_obj7, UitkBadgeTheme.LOYALTY_HIGH_TIER, UitkBadgeLoyaltyThemes.HIGH), _defineProperty(_obj7, UitkBadgeTheme.LOYALTY_MIDDLE_TIER, UitkBadgeLoyaltyThemes.MID), _defineProperty(_obj7, UitkBadgeTheme.LOYALTY_LOW_TIER, UitkBadgeLoyaltyThemes.LOW), _obj7);
// ../internal/src/components/lodging-badge/lodging-badge.tsx
var fragment23 = gql26(_templateObject25());
var LodgingBadge = function(param) {
    var propertyId = param.propertyId, className = param.className, isSRPListingCard = param.isSRPListingCard, data = param.data;
    if (!data || !data.text && !data.graphic) {
        return null;
    }
    var text = data.text, theme = data.theme, graphic = data.graphic, size = data.size;
    var graphics = function() {
        switch(graphic === null || graphic === void 0 ? void 0 : graphic.__typename){
            case "Icon":
                return graphic.id && /* @__PURE__ */ React23.createElement(UitkIcon6, {
                    name: graphic.id,
                    id: propertyId ? "mod-".concat(propertyId, "-title") : void 0,
                    description: graphic.description,
                    size: UitkIconSize5.SMALL
                });
            case "Mark":
                return graphic.id && /* @__PURE__ */ React23.createElement(UitkMark2, {
                    name: graphic.id,
                    description: graphic.description,
                    size: UitkMarkSize2.SMALL
                });
            default:
                return null;
        }
    };
    var DefaultUitkBadge = function() {
        return /* @__PURE__ */ React23.createElement(UitkBadge, {
            className: className,
            text: text || void 0,
            theme: theme ? UitkBadgeThemeMapper[theme] : void 0,
            size: size ? UitkBadgeSizeMapper[size] : void 0
        }, graphics());
    };
    if (theme && UitkBadgeLoyaltyThemeMapper[theme]) {
        return /* @__PURE__ */ React23.createElement(UitkBadgeLoyalty, {
            className: className,
            text: text || void 0,
            theme: theme ? UitkBadgeLoyaltyThemeMapper[theme] : void 0,
            size: size ? UitkBadgeSizeMapper[size] : void 0
        }, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && graphics());
    }
    if (theme === UitkBadgeThemeMapper.promoted) {
        return isSRPListingCard ? /* @__PURE__ */ React23.createElement(Experiment, {
            name: "MeSo_TravelAd_Standard_Badge"
        }, /* @__PURE__ */ React23.createElement(ExperimentControl, null, /* @__PURE__ */ React23.createElement(DefaultUitkBadge, null)), /* @__PURE__ */ React23.createElement(ExperimentVariant, {
            bucket: 1
        }, /* @__PURE__ */ React23.createElement(UitkBadgeStandard, {
            className: className,
            text: text || void 0,
            size: size ? UitkBadgeSizeMapper[size] : void 0,
            theme: "standard"
        }))) : /* @__PURE__ */ React23.createElement(DefaultUitkBadge, null);
    }
    if (theme && UitkBadgeStandardThemes[theme]) {
        return /* @__PURE__ */ React23.createElement(UitkBadgeStandard, {
            className: className,
            text: text || void 0,
            size: size ? UitkBadgeSizeMapper[size] : void 0,
            theme: theme ? UitkBadgeStandardThemes[theme] : void 0
        });
    }
    return /* @__PURE__ */ React23.createElement(DefaultUitkBadge, null);
};
LodgingBadge.fragment = fragment23;
LodgingBadge.displayName = "LodgingBadge";
// ../internal/src/components/lodging-gallery-carousel/lodging-gallery-carousel.tsx
import React26 from "react";
import { useHistory } from "react-router-dom";
import { gql as gql29 } from "@apollo/client";
import { IntersectionTracker, useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useProvidedState as useProvidedState2 } from "@shared-ui/provided-state-context";
import { UitkButtonTheme } from "uitk-react-button";
import { UitkGalleryCarousel } from "uitk-react-gallery-carousel";
import { UitkFigure as UitkFigure2, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage as UitkImage2 } from "uitk-react-images";
import { UitkLayoutPosition } from "uitk-react-layout-position";
// ../internal/src/components/lodging-gallery-carousel/lodging-media-item-to-uitk-media-mapper.tsx
var lodgingMediaItemToUitkMediaMapper = function(mediaItem) {
    switch(mediaItem.media.__typename){
        case "Image":
            return {
                src: mediaItem.media.url,
                alt: mediaItem.media.description
            };
        default:
            return {};
    }
};
// ../internal/src/components/lodging-media-item/lodging-media-item.tsx
import React25 from "react";
import { gql as gql28 } from "@apollo/client";
// ../internal/src/components/lodging-egds-image/lodging-egds-image.tsx
import React24 from "react";
import { gql as gql27 } from "@apollo/client";
import { UitkFigure, UitkImage } from "uitk-react-images";
var fragment24 = gql27(_templateObject26());
var LodgingEGDSImage = function(param) {
    var data = param.data, imageFit = param.imageFit, ratio = param.ratio, placeholderImage = param.placeholderImage, lazyLoad = param.lazyLoad;
    var figureProps = {};
    if (ratio) {
        figureProps.ratio = ratio;
    }
    if (imageFit) {
        figureProps.imageFit = imageFit;
    }
    return /* @__PURE__ */ React24.createElement(UitkFigure, _objectSpread({}, figureProps), /* @__PURE__ */ React24.createElement(UitkImage, {
        placeholderImage: placeholderImage,
        src: data.url,
        alt: data.description,
        lazyLoading: lazyLoad
    }));
};
LodgingEGDSImage.fragment = fragment24;
LodgingEGDSImage.displayName = "LodgingEGDSImage";
// ../internal/src/components/lodging-media-item/lodging-media-item.tsx
var fragment25 = gql28(_templateObject27(), LodgingEGDSImage.fragment);
var LodgingMediaItem = function(param) {
    var imageFit = param.imageFit, ratio = param.ratio, data = param.data, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? false : _param_lazyLoadImg;
    switch(data.media.__typename){
        case "Image":
            return /* @__PURE__ */ React25.createElement(LodgingEGDSImage, {
                imageFit: imageFit,
                ratio: ratio,
                placeholderImage: true,
                data: data.media,
                lazyLoad: lazyLoadImg ? "lazy" : "off"
            });
        default:
            return null;
    }
};
LodgingMediaItem.fragment = fragment25;
LodgingMediaItem.displayName = "LodgingProductMediaItem";
// ../internal/src/components/lodging-gallery-carousel/lodging-gallery-carousel.tsx
var fragment26 = gql29(_templateObject28(), LodgingMediaItem.fragment);
var LodgingGalleryCarousel = function(param) {
    var data = param.data, carouselId = param.carouselId, allyHeadingLevel = param.allyHeadingLevel, cardLink = param.cardLink, propertyId = param.propertyId, _param_imageRatio = param.imageRatio, imageRatio = _param_imageRatio === void 0 ? UitkFigureAspectRatioType2.R21_9 : _param_imageRatio, onClickCallback = param.onClickCallback, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? false : _param_lazyLoadImg;
    var media = data.media, accessibilityHeadingText = data.accessibilityHeadingText, navClickAnalytics = data.navClickAnalytics, intersectionAnalytics = data.intersectionAnalytics;
    var track = useClickTracker2();
    var _React26_useState = _slicedToArray(React26.useState(0), 2), currentMediaIndex = _React26_useState[0], setCurrentMediaIndex = _React26_useState[1];
    var _useProvidedState2 = _slicedToArray(useProvidedState2(), 1), lodgingCompareState = _useProvidedState2[0];
    var _lodgingCompareState_STATE_FIELD_NAME;
    var comparePropertyIds = ((_lodgingCompareState_STATE_FIELD_NAME = lodgingCompareState[STATE_FIELD_NAME]) !== null && _lodgingCompareState_STATE_FIELD_NAME !== void 0 ? _lodgingCompareState_STATE_FIELD_NAME : defaultState).comparePropertyIds;
    React26.useEffect(function() {
        setCurrentMediaIndex(0);
    }, [
        carouselId
    ]);
    var additionalUisPrimeMicroMessages = function(mdiaIndex) {
        var _media_mdiaIndex, _intersectionAnalytics_uisPrimeMessages;
        var iId = (_media_mdiaIndex = media[mdiaIndex]) === null || _media_mdiaIndex === void 0 ? void 0 : _media_mdiaIndex.id;
        var imageId = iId && parseInt(iId, 10);
        var productId = propertyId && parseInt(propertyId, 10);
        var messageContent = (intersectionAnalytics === null || intersectionAnalytics === void 0 ? void 0 : (_intersectionAnalytics_uisPrimeMessages = intersectionAnalytics.uisPrimeMessages) === null || _intersectionAnalytics_uisPrimeMessages === void 0 ? void 0 : _intersectionAnalytics_uisPrimeMessages.length) ? JSON.parse(intersectionAnalytics === null || intersectionAnalytics === void 0 ? void 0 : intersectionAnalytics.uisPrimeMessages[0].messageContent) : void 0;
        var badges = messageContent === null || messageContent === void 0 ? void 0 : messageContent.badges;
        return [
            {
                schemaName: "allHotelProducts",
                messageContent: {
                    numOfProducts: 1,
                    hotelProducts: [
                        {
                            productId: productId,
                            imageId: imageId,
                            imageGalleryAlgorithm: {
                                name: "heroaesthetics.v20190411-hsc.v20190223"
                            },
                            badges: badges
                        }
                    ]
                }
            }
        ];
    };
    var history = useHistory();
    var onImageClick = function() {
        var comparePropertyIdsStringToAppend = comparePropertyIds.length ? "&comparePropertyIds=".concat(comparePropertyIds.toString()) : "";
        if ((cardLink === null || cardLink === void 0 ? void 0 : cardLink.resource.__typename) === "HttpURI") {
            if (cardLink.target === "INTERNAL" /* INTERNAL */  && (cardLink === null || cardLink === void 0 ? void 0 : cardLink.useRelativePath)) {
                history.push(cardLink.resource.relativePath.concat(comparePropertyIdsStringToAppend));
            } else {
                var path = cardLink.useRelativePath ? cardLink.resource.relativePath.concat(comparePropertyIdsStringToAppend) : cardLink.resource.value.concat(comparePropertyIdsStringToAppend);
                window.open(path, UILinkTargetMap[cardLink.target]);
            }
            if (cardLink.analytics) {
                sendProductSchemaTracking(cardLink.analytics, track);
            }
        }
        var currentMedia = media[currentMediaIndex].media;
        if (currentMedia.__typename === "Image" && currentMedia.thumbnailClickAnalytics) {
            track(currentMedia.thumbnailClickAnalytics.referrerId, currentMedia.thumbnailClickAnalytics.linkName, true, additionalUisPrimeMicroMessages(currentMediaIndex));
        }
        if (onClickCallback) {
            onClickCallback();
        }
    };
    var navButtonAnalytics = navClickAnalytics ? {
        id: navClickAnalytics.referrerId,
        description: navClickAnalytics.linkName,
        callback: function(id, description) {
            return track(id, description, true, additionalUisPrimeMicroMessages(currentMediaIndex));
        }
    } : void 0;
    var galleryCarouselButtonText = data.nextButtonText && data.previousButtonText ? {
        nextButton: data.nextButtonText,
        prevButton: data.previousButtonText
    } : void 0;
    var galleryCarousel = media.length > 1 && /* @__PURE__ */ React26.createElement(UitkGalleryCarousel, {
        allyHeadingText: accessibilityHeadingText,
        allyHeadingLevel: allyHeadingLevel !== null && allyHeadingLevel !== void 0 ? allyHeadingLevel : void 0,
        carouselId: carouselId,
        carouselName: carouselId,
        currentIndex: currentMediaIndex,
        buttonText: galleryCarouselButtonText,
        images: media.map(function(mediaItem) {
            return lodgingMediaItemToUitkMediaMapper(mediaItem);
        }),
        onImageClick: cardLink ? onImageClick : void 0,
        onIndexChange: setCurrentMediaIndex,
        ratio: imageRatio,
        navTheme: UitkButtonTheme.TRANSPARENT,
        showGalleryButton: false,
        analytics: navButtonAnalytics,
        enablePreload: true,
        placeholderImage: true
    });
    switch(media.length){
        case 0:
            return /* @__PURE__ */ React26.createElement(UitkLayoutPosition, {
                position: {
                    zindex: "layer2"
                },
                cloneElement: true
            }, /* @__PURE__ */ React26.createElement(UitkFigure2, {
                imageFit: "cover",
                ratio: imageRatio
            }, /* @__PURE__ */ React26.createElement(UitkImage2, {
                placeholderImage: true,
                alt: ""
            })));
        case 1:
            return /* @__PURE__ */ React26.createElement(UitkLayoutPosition, {
                position: {
                    zindex: "layer2"
                },
                cloneElement: true
            }, /* @__PURE__ */ React26.createElement(LodgingMediaItem, {
                imageFit: "cover",
                ratio: imageRatio,
                data: media[0],
                lazyLoadImg: lazyLoadImg
            }));
        default:
            return /* @__PURE__ */ React26.createElement(UitkLayoutPosition, {
                position: {
                    zindex: "layer2"
                },
                cloneElement: true
            }, /* @__PURE__ */ React26.createElement(UitkFigure2, {
                imageFit: "cover",
                ratio: imageRatio
            }, intersectionAnalytics ? /* @__PURE__ */ React26.createElement(IntersectionTracker, {
                tag: "span",
                referrerId: intersectionAnalytics.referrerId,
                linkName: intersectionAnalytics.linkName,
                additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages(currentMediaIndex)
            }, galleryCarousel) : galleryCarousel));
    }
};
LodgingGalleryCarousel.fragment = fragment26;
LodgingGalleryCarousel.displayName = "LodgingGalleryCarousel";
// ../internal/src/components/lodging-trips-save-item/lodging-trips-save-item-adapter.tsx
import React28 from "react";
import { gql as gql31 } from "@apollo/client";
import { ITrackType as ITrackType3, useClickstreamAnalytics as useClickstreamAnalytics2 } from "@shared-ui/clickstream-analytics-context";
import { buildStateProvider } from "@shared-ui/provided-state-context";
import { Source, TripSaveItem, ValidatedInputsState } from "@shared-ui/trips-save-item";
// ../internal/src/components/common/adaptex/adaptex-analytics-events.tsx
import React27 from "react";
// ../internal/src/utils/adaptex-events-filter.ts
var filterAdaptExEventsByEventType = function(adaptexActionTracking, adaptExEvents) {
    var resultAdaptExEvents;
    if (adaptexActionTracking) {
        resultAdaptExEvents = adaptExEvents.reduce(function(results, adaptExEvent) {
            var foundTracking = adaptexActionTracking.find(function(tracking) {
                return tracking.campaignId === adaptExEvent.campaignId;
            });
            if (foundTracking) {
                var filteredEvents;
                if (foundTracking.eventTarget) {
                    filteredEvents = adaptExEvent.events.filter(function(event) {
                        return foundTracking.eventTarget === event.eventTarget;
                    });
                } else {
                    filteredEvents = adaptExEvent.events;
                }
                if ((filteredEvents === null || filteredEvents === void 0 ? void 0 : filteredEvents.length) > 0) {
                    results.push(_objectSpreadProps(_objectSpread({}, adaptExEvent), {
                        events: filteredEvents
                    }));
                }
            }
            return results;
        }, []);
    } else {
        resultAdaptExEvents = adaptExEvents;
    }
    return resultAdaptExEvents;
};
// ../internal/src/components/common/adaptex/adaptex-analytics-events.tsx
var initialAdaptExEvents = {
    adaptExSuccessEvents: []
};
var AdaptExEventsContext = React27.createContext(initialAdaptExEvents);
var useAdaptExEvents = function() {
    var adaptexSuccessActionTracking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var allAdaptExEvents = React27.useContext(AdaptExEventsContext);
    var resultAdaptExSuccessEvents = filterAdaptExEventsByEventType(adaptexSuccessActionTracking, allAdaptExEvents.adaptExSuccessEvents);
    return {
        adaptExSuccessEvents: resultAdaptExSuccessEvents
    };
};
// ../internal/src/components/common/adaptex/adaptex-success-action-tracking-fragment.ts
import { gql as gql30 } from "@apollo/client";
var AdaptexTrackingFragment = gql30(_templateObject29());
// ../internal/src/components/lodging-trips-save-item/lodging-trips-save-item-adapter.tsx
var fragment27 = gql31(_templateObject30(), AdaptexTrackingFragment);
var ValidatedInputsStateProvider = buildStateProvider(new ValidatedInputsState());
var LodgingTripsSaveItemAdapter = function(param) {
    var data = param.data;
    var save = data.save, remove = data.remove;
    var track = useClickstreamAnalytics2().track;
    var _save_adaptexSuccessCampaignIds;
    var _useAdaptExEvents = useAdaptExEvents((_save_adaptexSuccessCampaignIds = save.adaptexSuccessCampaignIds) !== null && _save_adaptexSuccessCampaignIds !== void 0 ? _save_adaptexSuccessCampaignIds : []), saveAdaptexSuccessEvents = _useAdaptExEvents.adaptExSuccessEvents;
    var _remove_adaptexSuccessCampaignIds;
    var _useAdaptExEvents1 = useAdaptExEvents((_remove_adaptexSuccessCampaignIds = remove.adaptexSuccessCampaignIds) !== null && _remove_adaptexSuccessCampaignIds !== void 0 ? _remove_adaptexSuccessCampaignIds : []), removeAdaptexSuccessEvents = _useAdaptExEvents1.adaptExSuccessEvents;
    var saveItemAdaptexTracking = React28.useCallback(function() {
        if (saveAdaptexSuccessEvents.length) {
            saveAdaptexSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType3.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    }, [
        saveAdaptexSuccessEvents,
        track
    ]);
    var removeItemAdaptexTracking = React28.useCallback(function() {
        if (removeAdaptexSuccessEvents.length) {
            removeAdaptexSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType3.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    }, [
        removeAdaptexSuccessEvents,
        track
    ]);
    return data && /* @__PURE__ */ React28.createElement(ValidatedInputsStateProvider, null, /* @__PURE__ */ React28.createElement(TripSaveItem, {
        data: data,
        source: Source.LODGING_SEARCH,
        heartLayoutPosition: {
            type: "absolute",
            position: {
                top: "zero",
                right: "zero",
                zindex: "layer2"
            }
        },
        saveItemCallback: saveItemAdaptexTracking,
        removeItemCallback: removeItemAdaptexTracking
    }));
};
LodgingTripsSaveItemAdapter.fragment = fragment27;
LodgingTripsSaveItemAdapter.displayName = "LodgingTripsSaveItemAdapter";
// ../internal/src/components/lodging-card/__private/lodging-card-save-item.tsx
import React29 from "react";
import { gql as gql32 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { ProductType, ShortlistToggle } from "@shared-ui/trip-planning-travelpulse";
var fragment28 = gql32(_templateObject31());
var LodgingCardSaveItem = function(param) {
    var data = param.data;
    var trackClick = useClickTracker3();
    var _React29_useState = _slicedToArray(React29.useState(data.initialChecked), 2), isChecked = _React29_useState[0], setIsChecked = _React29_useState[1];
    var items = data.items, labels = data.labels, messages = data.messages, initialChecked = data.initialChecked, analytics = data.analytics;
    var label = isChecked ? labels === null || labels === void 0 ? void 0 : labels.removeLabel : labels === null || labels === void 0 ? void 0 : labels.saveLabel;
    var inputs = {
        productId: items[0].itemId,
        productType: ProductType.PROPERTY_DETAILS
    };
    var handleChange = function(_previousChecked, currentChecked, dispatch) {
        setIsChecked(currentChecked);
        var referrerId = currentChecked ? "".concat(analytics === null || analytics === void 0 ? void 0 : analytics.linkName, ".Add to favorite lists") : "".concat(analytics === null || analytics === void 0 ? void 0 : analytics.linkName, ".Remove from favorite lists");
        var linkName = currentChecked ? "".concat(analytics === null || analytics === void 0 ? void 0 : analytics.referrerId, ".SaveFavorite") : "".concat(analytics === null || analytics === void 0 ? void 0 : analytics.referrerId, ".RemoveFavorite");
        trackClick(linkName, referrerId);
        var message = currentChecked ? messages === null || messages === void 0 ? void 0 : messages.saveMessage : messages === null || messages === void 0 ? void 0 : messages.removeMessage;
        if (message) {
            dispatch({
                message: message
            });
        }
    };
    return /* @__PURE__ */ React29.createElement(ShortlistToggle, {
        inputs: inputs,
        initialChecked: initialChecked,
        label: label || void 0,
        onChange: handleChange
    });
};
LodgingCardSaveItem.fragment = fragment28;
LodgingCardSaveItem.displayName = "LodgingCardSaveItem";
// ../internal/src/components/lodging-card/__private/lodging-card-media-section.tsx
var fragment29 = gql33(_templateObject32(), LodgingBadge.fragment, LodgingGalleryCarousel.fragment, LodgingCardSaveItem.fragment, LodgingTripsSaveItemAdapter.fragment);
var LodgingCardMediaSection = function(param) {
    var cardLink = param.cardLink, propertyId = param.propertyId, _param_view = param.view, view = _param_view === void 0 ? "RESPONSIVE" /* RESPONSIVE */  : _param_view, data = param.data, imageRatio = param.imageRatio, onClickCallback = param.onClickCallback, index = param.index, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? false : _param_lazyLoadImg, isSRPListingCard = param.isSRPListingCard;
    var badges = data.badges, gallery = data.gallery, saveItem = data.saveItem, saveTripItem = data.saveTripItem;
    var carouselFigure = gallery ? /* @__PURE__ */ React30.createElement(LodgingGalleryCarousel, {
        data: gallery,
        carouselId: "lodging-card-gallery-carousel-".concat(propertyId, "-").concat(index),
        allyHeadingLevel: "h3",
        cardLink: cardLink,
        propertyId: propertyId,
        imageRatio: imageRatio,
        onClickCallback: onClickCallback,
        lazyLoadImg: lazyLoadImg
    }) : /* @__PURE__ */ React30.createElement(UitkFigure3, {
        additionalProps: {
            "data-stid": "lodging-card-media-section-placeholder-image"
        }
    }, /* @__PURE__ */ React30.createElement(UitkImage3, {
        placeholderImage: true,
        alt: ""
    }));
    var tertiaryLodgingBadge;
    if (badges === null || badges === void 0 ? void 0 : badges.tertiaryBadge) {
        var tertiaryBadgeContent = /* @__PURE__ */ React30.createElement(UitkLayoutPosition2, {
            type: "absolute",
            position: {
                right: "three",
                bottom: "minus-three",
                zindex: "layer2"
            },
            cloneElement: true
        }, /* @__PURE__ */ React30.createElement(LodgingBadge, {
            data: badges.tertiaryBadge,
            propertyId: propertyId
        }));
        if (!isCompactHorizontalView(view)) {
            tertiaryLodgingBadge = isCompactView(view) ? tertiaryBadgeContent : /* @__PURE__ */ React30.createElement(Viewport, null, /* @__PURE__ */ React30.createElement(ViewSmall, null, tertiaryBadgeContent), /* @__PURE__ */ React30.createElement(ViewMedium, null));
        }
    }
    var shortlistToggle = saveItem && !isCompactHorizontalView(view) && /* @__PURE__ */ React30.createElement(UitkLayoutPosition2, {
        type: "absolute",
        position: {
            top: "zero",
            right: "zero",
            zindex: "layer2"
        }
    }, /* @__PURE__ */ React30.createElement(LodgingCardSaveItem, {
        data: saveItem
    }));
    var compactViewShortlistToggle = saveItem && isCompactHorizontalView(view) && /* @__PURE__ */ React30.createElement(UitkLayoutPosition2, {
        type: "absolute",
        position: {
            top: "zero",
            left: "zero",
            zindex: "layer2"
        }
    }, /* @__PURE__ */ React30.createElement(LodgingCardSaveItem, {
        data: saveItem
    }));
    var saveTripItemHeart = saveTripItem && /* @__PURE__ */ React30.createElement(LodgingTripsSaveItemAdapter, {
        data: saveTripItem
    });
    var primaryLodgingBadge = (badges === null || badges === void 0 ? void 0 : badges.primaryBadge) && /* @__PURE__ */ React30.createElement(UitkLayoutPosition2, {
        type: "absolute",
        position: {
            left: "three",
            top: "three",
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React30.createElement(LodgingBadge, {
        data: badges.primaryBadge
    }));
    var secondaryLodgingBadge = (badges === null || badges === void 0 ? void 0 : badges.secondaryBadge) && /* @__PURE__ */ React30.createElement(UitkLayoutPosition2, {
        type: "absolute",
        position: {
            bottom: "three",
            left: "three",
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React30.createElement(LodgingBadge, {
        isSRPListingCard: isSRPListingCard,
        data: badges.secondaryBadge
    }));
    return /* @__PURE__ */ React30.createElement(UitkLayoutPosition2, {
        type: "relative",
        position: {
            top: "zero",
            left: "zero"
        },
        cloneElement: true
    }, /* @__PURE__ */ React30.createElement(UitkLayoutFlex3, {
        blockSize: "full_size"
    }, carouselFigure, shortlistToggle, compactViewShortlistToggle, saveTripItemHeart, primaryLodgingBadge, secondaryLodgingBadge, tertiaryLodgingBadge));
};
LodgingCardMediaSection.fragment = fragment29;
LodgingCardMediaSection.displayName = "LodgingCardMediaSection";
// ../internal/src/components/lodging-egds-rating/lodging-egds-rating.tsx
import React31 from "react";
import { gql as gql34 } from "@apollo/client";
import { UitkRating } from "uitk-react-rating";
var fragment30 = gql34(_templateObject33());
var LodgingEGDSRating = function(param) {
    var data = param.data;
    var icon = data.icon;
    var _data_accessibility;
    return /* @__PURE__ */ React31.createElement(UitkRating, {
        icon: icon === null || icon === void 0 ? void 0 : icon.id,
        rating: String(data.rating),
        a11yText: (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : void 0
    });
};
LodgingEGDSRating.fragment = fragment30;
LodgingEGDSRating.displayName = "LodgingEGDSRating";
// src/components/compare/__private/__fragments/lodging-compare-badge.tsx
import React32 from "react";
import { gql as gql35 } from "@apollo/client";
import { UitkText as UitkText7 } from "uitk-react-text";
var fragment31 = gql35(_templateObject34());
var LodgingCompareBadge = function(param) {
    var data = param.data;
    return !data.text ? null : /* @__PURE__ */ React32.createElement(UitkText7, {
        size: 200,
        weight: "medium",
        theme: "emphasis"
    }, data.text);
};
LodgingCompareBadge.fragment = fragment31;
LodgingCompareBadge.displayName = "LodgingCompareBadge";
// src/components/compare/__private/__fragments/lodging-compare-cell.tsx
import React39 from "react";
import { gql as gql39 } from "@apollo/client";
import { UitkTableCell, UitkTableCellBorder } from "uitk-react-tables";
// src/components/compare/__private/__fragments/lodging-compare-cell-content.tsx
import React38 from "react";
import { gql as gql38 } from "@apollo/client";
// ../internal/src/components/lodging-card/lodging-card-price-section-price-summary.tsx
import React36 from "react";
import { PriceSummary } from "@shared-ui/pricing-price-summary";
import { UitkPriceLockupAlign as UitkPriceLockupAlign2 } from "uitk-react-price-lockup";
// ../internal/src/components/lodging-price-summary.tsx
import React35 from "react";
import { gql as gql36 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from "uitk-react-dialog";
import { UitkPriceLockup, UitkPriceLockupAlign } from "uitk-react-price-lockup";
// ../internal/src/utils/use-dialog-id.ts
import React33 from "react";
var useDialogId = function() {
    return React33.useMemo(function() {
        return Math.random().toString(36).slice(2, 7);
    }, []);
};
// ../internal/src/components/dialog-context.tsx
import React34 from "react";
var DialogContext = React34.createContext(false);
var dialog_context_default = DialogContext;
// ../internal/src/components/lodging-price-summary.tsx
var fragment32 = gql36(_templateObject35());
var formatStrikeOutText = function(price, points, unit, leadingCaption, isPointsFirst) {
    if (!price && !points) {
        return void 0;
    }
    if (!points) {
        return price === null || price === void 0 ? void 0 : price.formatted;
    }
    if (!price) {
        return "".concat(points.formatted, " ").concat(unit);
    }
    if (isPointsFirst) {
        return "".concat(points.formatted, " ").concat(unit, " ").concat(leadingCaption, " ").concat(price.formatted);
    }
    return "".concat(price.formatted, " ").concat(leadingCaption, " ").concat(points.formatted, " ").concat(unit);
};
var buildUitkPriceLockupProps = function(options) {
    var _loyaltyPoints_amount, _priceDisclaimer_trigger, _priceDisclaimer_trigger_icon;
    var _options = _slicedToArray(options, 3), leadOption = _options[0], otherOption = _options[1], disclaimerForPoints = _options[2];
    var leadingCaption = leadOption.leadingCaption, loyaltyPrice = leadOption.loyaltyPrice, displayPrice = leadOption.displayPrice, accessibilityLabel = leadOption.accessibilityLabel, priceDisclaimer = leadOption.priceDisclaimer, strikeOut = leadOption.strikeOut;
    if (options.length === 1 && loyaltyPrice) {
        var _loyaltyPrice_totalStrikeOutPoints, _loyaltyPrice_amount;
        var strikeThroughPoints = loyaltyPrice.totalStrikeOutPoints ? "".concat((_loyaltyPrice_totalStrikeOutPoints = loyaltyPrice.totalStrikeOutPoints) === null || _loyaltyPrice_totalStrikeOutPoints === void 0 ? void 0 : _loyaltyPrice_totalStrikeOutPoints.formatted, " ").concat(loyaltyPrice.unit) : "";
        return {
            isStrikeThroughFirst: true,
            lockupFormattedPoints: "".concat((_loyaltyPrice_amount = loyaltyPrice.amount) === null || _loyaltyPrice_amount === void 0 ? void 0 : _loyaltyPrice_amount.formatted, " ").concat(loyaltyPrice.unit),
            strikeThroughPrice: strikeThroughPoints,
            a11yPrice: accessibilityLabel || ""
        };
    }
    if (loyaltyPrice) {
        var _otherOption_displayPrice, _loyaltyPrice_amount1, _disclaimerForPoints_priceDisclaimer, _disclaimerForPoints_priceDisclaimer_trigger, _disclaimerForPoints_priceDisclaimer_trigger_icon;
        var moneyPrice = "".concat(otherOption.leadingCaption, " ").concat((_otherOption_displayPrice = otherOption.displayPrice) === null || _otherOption_displayPrice === void 0 ? void 0 : _otherOption_displayPrice.formatted);
        return {
            isStrikeThroughFirst: true,
            isPointsFirst: true,
            lockupPrice: moneyPrice,
            lockupFormattedPoints: "".concat((_loyaltyPrice_amount1 = loyaltyPrice.amount) === null || _loyaltyPrice_amount1 === void 0 ? void 0 : _loyaltyPrice_amount1.formatted, " ").concat(loyaltyPrice.unit),
            a11yPrice: otherOption.accessibilityLabel || "",
            strikeThroughPrice: formatStrikeOutText(disclaimerForPoints === null || disclaimerForPoints === void 0 ? void 0 : disclaimerForPoints.strikeOut, loyaltyPrice.totalStrikeOutPoints, loyaltyPrice.unit, otherOption.leadingCaption, true),
            a11yStrikeThroughDialogTrigger: disclaimerForPoints === null || disclaimerForPoints === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer = disclaimerForPoints.priceDisclaimer) === null || _disclaimerForPoints_priceDisclaimer === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer_trigger = _disclaimerForPoints_priceDisclaimer.trigger) === null || _disclaimerForPoints_priceDisclaimer_trigger === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer_trigger_icon = _disclaimerForPoints_priceDisclaimer_trigger.icon) === null || _disclaimerForPoints_priceDisclaimer_trigger_icon === void 0 ? void 0 : _disclaimerForPoints_priceDisclaimer_trigger_icon.description
        };
    }
    var leadPrice = leadingCaption ? "".concat(leadingCaption, " ").concat(displayPrice === null || displayPrice === void 0 ? void 0 : displayPrice.formatted) : displayPrice === null || displayPrice === void 0 ? void 0 : displayPrice.formatted;
    if (options.length === 1) {
        var _priceDisclaimer_trigger1, _priceDisclaimer_trigger_icon1;
        return {
            lockupPrice: leadPrice,
            a11yPrice: accessibilityLabel || "",
            strikeThroughPrice: strikeOut === null || strikeOut === void 0 ? void 0 : strikeOut.formatted,
            a11yStrikeThroughDialogTrigger: priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger1 = priceDisclaimer.trigger) === null || _priceDisclaimer_trigger1 === void 0 ? void 0 : (_priceDisclaimer_trigger_icon1 = _priceDisclaimer_trigger1.icon) === null || _priceDisclaimer_trigger_icon1 === void 0 ? void 0 : _priceDisclaimer_trigger_icon1.description
        };
    }
    var loyaltyPoints = otherOption.loyaltyPrice;
    return {
        isStrikeThroughFirst: true,
        isPointsFirst: false,
        strikeThroughPrice: formatStrikeOutText(strikeOut, loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : loyaltyPoints.totalStrikeOutPoints, loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : loyaltyPoints.unit, otherOption.leadingCaption, false),
        lockupPrice: leadPrice,
        lockupFormattedPoints: "".concat(otherOption.leadingCaption, " ").concat(loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : (_loyaltyPoints_amount = loyaltyPoints.amount) === null || _loyaltyPoints_amount === void 0 ? void 0 : _loyaltyPoints_amount.formatted, " ").concat(loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : loyaltyPoints.unit),
        a11yStrikeThroughDialogTrigger: priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger = priceDisclaimer.trigger) === null || _priceDisclaimer_trigger === void 0 ? void 0 : (_priceDisclaimer_trigger_icon = _priceDisclaimer_trigger.icon) === null || _priceDisclaimer_trigger_icon === void 0 ? void 0 : _priceDisclaimer_trigger_icon.description,
        a11yPrice: accessibilityLabel || ""
    };
};
var getPriceDisclaimer = function(options) {
    var _options_;
    return options[0].priceDisclaimer || ((_options_ = options[2]) === null || _options_ === void 0 ? void 0 : _options_.priceDisclaimer);
};
var LodgingPriceSummary = function(param) {
    var _param_showPriceDetails = param.showPriceDetails, showPriceDetails = _param_showPriceDetails === void 0 ? true : _param_showPriceDetails, _param_align = param.align, align = _param_align === void 0 ? UitkPriceLockupAlign.LEFT : _param_align, data = param.data;
    var _priceDisclaimer_primaryButton;
    var price = data.price;
    var trackClick = useClickTracker4();
    var dialogPostfix = useDialogId();
    var _useDialog = _slicedToArray(useDialog("property-price-messaging-dialog-".concat(dialogPostfix), "pwaDialogNested"), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var isWithinDetailsDialog = React35.useContext(dialog_context_default);
    if (!(price === null || price === void 0 ? void 0 : price.options) || price.options.length === 0) {
        return null;
    }
    var priceMessaging = price.priceMessaging, options = price.options;
    var priceSubtextBoldIndex = (priceMessaging === null || priceMessaging === void 0 ? void 0 : priceMessaging.findIndex(function(msg) {
        return msg.theme === "STRONG" /* STRONG */ ;
    })) || -1;
    var priceSubtextStandardRawData = priceSubtextBoldIndex === -1 ? priceMessaging === null || priceMessaging === void 0 ? void 0 : priceMessaging.slice(1) : priceMessaging === null || priceMessaging === void 0 ? void 0 : priceMessaging.slice(1).splice(priceSubtextBoldIndex, 1);
    var priceSubtextStandard = priceSubtextStandardRawData === null || priceSubtextStandardRawData === void 0 ? void 0 : priceSubtextStandardRawData.map(function(msg) {
        return msg.value;
    });
    var openStrikeThroughPriceDialog = function() {
        dialogActions.openDialog();
        trackClick("HOT.HIS.Price.DisclaimerDialog", "Price Disclaimer Dialog");
    };
    var priceProps = buildUitkPriceLockupProps(options);
    var priceDisclaimer = getPriceDisclaimer(options);
    return /* @__PURE__ */ React35.createElement("div", null, /* @__PURE__ */ React35.createElement(UitkPriceLockup, _objectSpreadProps(_objectSpread({}, priceProps), {
        align: align,
        priceSubtextFirst: showPriceDetails && priceMessaging ? priceMessaging[0].value : "",
        priceSubtextStandard: showPriceDetails ? priceSubtextStandard : void 0,
        priceSubtextBold: showPriceDetails && priceMessaging && priceSubtextBoldIndex !== -1 ? priceMessaging[priceSubtextBoldIndex].value : "",
        strikeThroughTrigger: !!priceDisclaimer && /* @__PURE__ */ React35.createElement("button", {
            onClick: openStrikeThroughPriceDialog,
            type: "button",
            className: "uitk-more-info-trigger"
        }),
        stids: {
            lockupId: "price-lockup-text",
            subtextBoldId: "price-lockup-bold-subtext",
            wrapperId: "price-lockup-wrapper"
        }
    })), !!priceDisclaimer && !isWithinDetailsDialog && /* @__PURE__ */ React35.createElement(DialogComponent, null, /* @__PURE__ */ React35.createElement(UitkDialog, {
        dialogShow: isDialogOpen,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React35.createElement(UitkDialogContent, null, priceDisclaimer.content[0], /* @__PURE__ */ React35.createElement(UitkDialogFooter, {
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: ((_priceDisclaimer_primaryButton = priceDisclaimer.primaryButton) === null || _priceDisclaimer_primaryButton === void 0 ? void 0 : _priceDisclaimer_primaryButton.text) || "",
            type: "tertiary"
        }
    })))));
};
LodgingPriceSummary.fragment = fragment32;
LodgingPriceSummary.displayName = "LodgingPriceSummary";
// ../internal/src/components/lodging-card/lodging-card-price-section-price-summary.tsx
var mapPriceSummary = function(priceSummary) {
    var price = {
        __typename: "Offer",
        price: priceSummary
    };
    return price;
};
var PriceSectionPriceSummary = function(param) {
    var priceSection = param.priceSection, flexAlignment = param.flexAlignment, _param_align = param.align, align = _param_align === void 0 ? UitkPriceLockupAlign2.RIGHT : _param_align, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var _priceSection_priceSummary, _priceSection_priceSummary_displayMessages;
    return ((_priceSection_priceSummary = priceSection.priceSummary) === null || _priceSection_priceSummary === void 0 ? void 0 : (_priceSection_priceSummary_displayMessages = _priceSection_priceSummary.displayMessages) === null || _priceSection_priceSummary_displayMessages === void 0 ? void 0 : _priceSection_priceSummary_displayMessages.length) ? /* @__PURE__ */ React36.createElement(PriceSummary, {
        data: priceSection.priceSummary,
        flexAlignment: flexAlignment,
        enableInlineLink: enableInlineLink
    }) : /* @__PURE__ */ React36.createElement(LodgingPriceSummary, {
        align: align,
        data: mapPriceSummary(priceSection.priceSummary)
    });
};
// src/components/compare/__private/__fragments/lodging-compare-text-items.tsx
import React37 from "react";
import { gql as gql37 } from "@apollo/client";
import { UitkList, UitkListItem } from "uitk-react-list";
var fragment33 = gql37(_templateObject36());
var isIconListItem = function(item) {
    var _item_graphic, _item_text;
    return Boolean((item === null || item === void 0 ? void 0 : (_item_graphic = item.graphic) === null || _item_graphic === void 0 ? void 0 : _item_graphic.__typename) === "Icon" && ((_item_text = item.text) === null || _item_text === void 0 ? void 0 : _item_text.__typename));
};
var LodgingCompareTextItems = function(param) {
    var data = param.data;
    var items = data.items;
    if ((items === null || items === void 0 ? void 0 : items.length) && items.every(isIconListItem)) {
        var size = items[0].text.size;
        return /* @__PURE__ */ React37.createElement(UitkList, {
            bullet: "icon-standard",
            size: size === "200" ? 3 : void 0,
            spacing: false
        }, items.map(function(item, index) {
            return /* @__PURE__ */ React37.createElement(UitkListItem, {
                key: index
            }, /* @__PURE__ */ React37.createElement(Icon, {
                data: item.graphic
            }), /* @__PURE__ */ React37.createElement(EGDSStylizedText, {
                inline: true,
                data: item.text
            }));
        }));
    }
    return /* @__PURE__ */ React37.createElement(React37.Fragment, null, items === null || items === void 0 ? void 0 : items.map(function(item, index) {
        /* @__PURE__ */ return React37.createElement("div", {
            key: index
        }, (item === null || item === void 0 ? void 0 : item.graphic) && /* @__PURE__ */ React37.createElement(UiGraphic, {
            data: item.graphic
        }), (item === null || item === void 0 ? void 0 : item.text) && /* @__PURE__ */ React37.createElement(EGDSStylizedText, {
            inline: true,
            data: item.text
        }));
    }));
};
LodgingCompareTextItems.fragment = fragment33;
LodgingCompareTextItems.displayName = "LodgingCompareTextItems";
// src/components/compare/__private/__fragments/lodging-compare-cell-content.tsx
var fragment34 = gql38(_templateObject37());
var LodgingCompareCellContent = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "EGDSIconRating":
            return /* @__PURE__ */ React38.createElement(LodgingEGDSRating, {
                data: data
            });
        case "LodgingCompareTextItems":
            return /* @__PURE__ */ React38.createElement(LodgingCompareTextItems, {
                data: data
            });
        case "LodgingCardPhrase":
            return /* @__PURE__ */ React38.createElement(LodgingCardGuestRating, {
                data: data
            });
        case "LodgingCardPriceSection":
            {
                return /* @__PURE__ */ React38.createElement(React38.Fragment, null, data.badge && /* @__PURE__ */ React38.createElement(LodgingCompareBadge, {
                    data: data.badge
                }), /* @__PURE__ */ React38.createElement(PriceSectionPriceSummary, {
                    priceSection: data,
                    flexAlignment: "start"
                }));
            }
        default:
            return null;
    }
};
LodgingCompareCellContent.fragment = fragment34;
LodgingCompareCellContent.displayName = "LodgingCompareCellContent";
// src/components/compare/__private/__fragments/lodging-compare-cell.tsx
var fragment35 = gql39(_templateObject38());
var LodgingCompareCell = function(param) {
    var data = param.data;
    var _data_content;
    /* @__PURE__ */ return React39.createElement(UitkTableCell, {
        border: [
            UitkTableCellBorder.horizontal,
            UitkTableCellBorder.vertical
        ],
        align: ((_data_content = data.content) === null || _data_content === void 0 ? void 0 : _data_content.__typename) === "LodgingCardPriceSection" ? {
            vertical: "bottom"
        } : void 0
    }, (data === null || data === void 0 ? void 0 : data.content) && /* @__PURE__ */ React39.createElement(LodgingCompareCellContent, {
        data: data.content
    }));
};
LodgingCompareCell.fragment = fragment35;
LodgingCompareCell.displayName = "LodgingCompareCell";
// src/components/compare/__private/__fragments/lodging-compare-loading.tsx
import React40, { useMemo as useMemo3 } from "react";
import { useProvidedState as useProvidedState3 } from "@shared-ui/provided-state-context";
import { UitkFigure as UitkFigure4, UitkFigureAspectRatioType as UitkFigureAspectRatioType4 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkScrollable } from "uitk-react-scrollable";
import { UitkBlockSkeleton, UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkTable, UitkTableBody, UitkTableCell as UitkTableCell2, UitkTableCellBorder as UitkTableCellBorder2, UitkTableCellPadding, UitkTableRow } from "uitk-react-tables";
var rows = new Array(5).fill(null);
var LodgingCompareLoading = function() {
    var _useProvidedState3 = _slicedToArray(useProvidedState3(), 1), state = _useProvidedState3[0];
    var _state_STATE_FIELD_NAME;
    var comparePropertyIds = ((_state_STATE_FIELD_NAME = state[STATE_FIELD_NAME]) !== null && _state_STATE_FIELD_NAME !== void 0 ? _state_STATE_FIELD_NAME : defaultState).comparePropertyIds;
    var columns = useMemo3(function() {
        return new Array(_toConsumableArray(new Set(comparePropertyIds.map(getPropertyIdFromCardId))).length).fill(null);
    }, [
        comparePropertyIds
    ]);
    return /* @__PURE__ */ React40.createElement(UitkScrollable, {
        direction: "horizontal"
    }, /* @__PURE__ */ React40.createElement(UitkLayoutFlexItem3, {
        grow: 1
    }, /* @__PURE__ */ React40.createElement(UitkLayoutFlex4, {
        justifyContent: "center"
    }, /* @__PURE__ */ React40.createElement(UitkLayoutFlexItem3, {
        minWidth: "zero"
    }, /* @__PURE__ */ React40.createElement("div", null, /* @__PURE__ */ React40.createElement(UitkTable, {
        overflow: false
    }, /* @__PURE__ */ React40.createElement(UitkTableBody, null, /* @__PURE__ */ React40.createElement(React40.Fragment, null, /* @__PURE__ */ React40.createElement(UitkTableRow, null, columns.map(function(_, index) {
        return /* @__PURE__ */ React40.createElement(UitkTableCell2, {
            key: index,
            border: UitkTableCellBorder2.vertical,
            padding: UitkTableCellPadding.zero
        }, /* @__PURE__ */ React40.createElement(UitkFigure4, {
            ratio: UitkFigureAspectRatioType4.R1_1
        }, /* @__PURE__ */ React40.createElement(UitkBlockSkeleton, null)));
    })), /* @__PURE__ */ React40.createElement(UitkTableRow, null, columns.map(function(__, index) {
        return /* @__PURE__ */ React40.createElement(UitkTableCell2, {
            key: index,
            padding: UitkTableCellPadding.zero
        }, /* @__PURE__ */ React40.createElement(UitkSpacing3, {
            padding: {
                inlineend: "one",
                blockend: "four",
                blockstart: "three"
            }
        }, /* @__PURE__ */ React40.createElement(UitkLayoutGrid2, {
            columns: [
                "minmax(104px, 104px)"
            ]
        }, /* @__PURE__ */ React40.createElement(UitkLayoutGridItem2, null, /* @__PURE__ */ React40.createElement("div", null, /* @__PURE__ */ React40.createElement(UitkSpacing3, {
            margin: {
                blockend: "two"
            }
        }, /* @__PURE__ */ React40.createElement(UitkLineSkeleton, null)), /* @__PURE__ */ React40.createElement(UitkLineSkeleton, {
            type: "secondary"
        }))))));
    })), rows.map(function(_, rowIndex) {
        return /* @__PURE__ */ React40.createElement(UitkTableRow, {
            key: rowIndex
        }, columns.map(function(__, index) {
            return /* @__PURE__ */ React40.createElement(UitkTableCell2, {
                key: index,
                padding: "zero"
            }, /* @__PURE__ */ React40.createElement(UitkSpacing3, {
                margin: {
                    inlineend: "one",
                    blockend: "four",
                    blockstart: "four"
                }
            }, /* @__PURE__ */ React40.createElement(UitkLineSkeleton, {
                type: "secondary"
            })));
        }));
    })))))))));
};
// src/components/compare/__private/__fragments/lodging-compare-remove-action.tsx
import React41, { useCallback as useCallback4 } from "react";
import { gql as gql40 } from "@apollo/client";
import { useProvidedState as useProvidedState4 } from "@shared-ui/provided-state-context";
var fragment36 = gql40(_templateObject39());
var LodgingCompareRemoveAction = function(param) {
    var data = param.data;
    var propertyId = data.propertyId;
    var _useProvidedState4 = _slicedToArray(useProvidedState4(), 2), dispatch = _useProvidedState4[1];
    var handleClick = useCallback4(function() {
        if (propertyId) {
            dispatch({
                type: REMOVE_COMPARE_PROPERTY,
                payload: {
                    propertyId: propertyId
                }
            });
        }
    }, [
        propertyId,
        dispatch
    ]);
    return data.action && /* @__PURE__ */ React41.createElement(LodgingEGDSButton, {
        data: data.action,
        onClick: handleClick
    });
};
LodgingCompareRemoveAction.fragment = fragment36;
LodgingCompareRemoveAction.displayName = "LodgingCompareRemoveAction";
// src/components/compare/__private/__fragments/lodging-compare-section.tsx
import React43, { useMemo as useMemo4 } from "react";
import { gql as gql41 } from "@apollo/client";
import { useProvidedState as useProvidedState5 } from "@shared-ui/provided-state-context";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType5 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkTable as UitkTable2, UitkTableBody as UitkTableBody2, UitkTableCell as UitkTableCell4, UitkTableCellBorder as UitkTableCellBorder4, UitkTableCellPadding as UitkTableCellPadding3, UitkTableRow as UitkTableRow2 } from "uitk-react-tables";
// src/components/compare/__private/__fragments/lodging-compare-cell-header.tsx
import React42 from "react";
import { UitkLayoutGrid as UitkLayoutGrid3, UitkLayoutGridItem as UitkLayoutGridItem3 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkTableCell as UitkTableCell3, UitkTableCellBorder as UitkTableCellBorder3, UitkTableCellHeaderScope, UitkTableCellPadding as UitkTableCellPadding2, UitkTableCellTag } from "uitk-react-tables";
import { UitkText as UitkText8 } from "uitk-react-text";
var LodgingCompareCellHeader = function(param) {
    var data = param.data;
    /* @__PURE__ */ return React42.createElement(UitkTableCell3, {
        border: [
            UitkTableCellBorder3.horizontal,
            UitkTableCellBorder3.vertical
        ],
        tag: UitkTableCellTag.header,
        scope: UitkTableCellHeaderScope.column,
        padding: UitkTableCellPadding2.zero
    }, /* @__PURE__ */ React42.createElement(UitkSpacing4, {
        padding: "three"
    }, /* @__PURE__ */ React42.createElement(UitkLayoutGrid3, {
        columns: [
            "minmax(104px, 104px)"
        ]
    }, /* @__PURE__ */ React42.createElement(UitkLayoutGridItem3, null, /* @__PURE__ */ React42.createElement(UitkSpacing4, null, /* @__PURE__ */ React42.createElement(UitkText8, {
        whiteSpace: "normal"
    }, (data === null || data === void 0 ? void 0 : data.content) && /* @__PURE__ */ React42.createElement(LodgingCompareCellContent, {
        data: data.content
    })))))));
};
LodgingCompareCellHeader.displayName = "LodgingCompareCellHeader";
// src/components/compare/__private/__fragments/lodging-compare-section.tsx
var fragment37 = gql41(_templateObject40());
var hasData = function(array) {
    return Boolean((array === null || array === void 0 ? void 0 : array.length) && !array.every(function(value) {
        return value === null;
    }));
};
var _value_propertyId;
var hasPropertyId = function(value) {
    return ((_value_propertyId = value === null || value === void 0 ? void 0 : value.propertyId) !== null && _value_propertyId !== void 0 ? _value_propertyId : null) !== null;
};
var LodgingCompareSection = function(param) {
    var data = param.data;
    var _useProvidedState5 = _slicedToArray(useProvidedState5(), 1), state = _useProvidedState5[0];
    var _state_STATE_FIELD_NAME;
    var comparePropertyIds = ((_state_STATE_FIELD_NAME = state[STATE_FIELD_NAME]) !== null && _state_STATE_FIELD_NAME !== void 0 ? _state_STATE_FIELD_NAME : defaultState).comparePropertyIds;
    var _useMemo4 = useMemo4(function() {
        var _data_removeRow, _data_mediaRow, _data_viewRow;
        if (!(((_data_removeRow = data.removeRow) === null || _data_removeRow === void 0 ? void 0 : _data_removeRow.length) && data.removeRow.every(hasPropertyId))) {
            return data;
        }
        var selectedCardIds = new Set(comparePropertyIds.map(getPropertyIdFromCardId));
        var selectedIndexes = new Set(data.removeRow.reduce(function(acc, action, index) {
            return selectedCardIds.has(action.propertyId) ? _toConsumableArray(acc).concat([
                index
            ]) : acc;
        }, []));
        var isSelected = function(_, index) {
            return selectedIndexes.has(index);
        };
        var _data_mediaRow_filter, _data_viewRow_filter, _data_removeRow_filter;
        var filteredData = _objectSpreadProps(_objectSpread({}, data), {
            mediaRow: (_data_mediaRow_filter = (_data_mediaRow = data.mediaRow) === null || _data_mediaRow === void 0 ? void 0 : _data_mediaRow.filter(isSelected)) !== null && _data_mediaRow_filter !== void 0 ? _data_mediaRow_filter : null,
            compareRows: data.compareRows.map(function(row) {
                return row && _objectSpreadProps(_objectSpread({}, row), {
                    cells: row.cells.filter(isSelected)
                });
            }),
            viewRow: (_data_viewRow_filter = (_data_viewRow = data.viewRow) === null || _data_viewRow === void 0 ? void 0 : _data_viewRow.filter(isSelected)) !== null && _data_viewRow_filter !== void 0 ? _data_viewRow_filter : null,
            removeRow: (_data_removeRow_filter = data.removeRow.filter(isSelected)) !== null && _data_removeRow_filter !== void 0 ? _data_removeRow_filter : null
        });
        return filteredData;
    }, [
        comparePropertyIds,
        data
    ]), mediaRow = _useMemo4.mediaRow, compareRows = _useMemo4.compareRows, viewRow = _useMemo4.viewRow, removeRow = _useMemo4.removeRow;
    var _action_propertyId, _removeRow_map;
    var keys = (_removeRow_map = removeRow === null || removeRow === void 0 ? void 0 : removeRow.map(function(action, index) {
        return (_action_propertyId = action === null || action === void 0 ? void 0 : action.propertyId) !== null && _action_propertyId !== void 0 ? _action_propertyId : index;
    })) !== null && _removeRow_map !== void 0 ? _removeRow_map : [];
    var _keys_index;
    var getKey = function(index) {
        return (_keys_index = keys[index]) !== null && _keys_index !== void 0 ? _keys_index : index;
    };
    return /* @__PURE__ */ React43.createElement(UitkLayoutFlex5, null, /* @__PURE__ */ React43.createElement(UitkLayoutFlexItem4, {
        grow: 1
    }, /* @__PURE__ */ React43.createElement("div", null)), /* @__PURE__ */ React43.createElement(UitkSpacing5, {
        padding: {
            inline: "six"
        }
    }, /* @__PURE__ */ React43.createElement(UitkLayoutFlexItem4, {
        minWidth: "zero"
    }, /* @__PURE__ */ React43.createElement("div", null, /* @__PURE__ */ React43.createElement(UitkTable2, {
        border: true,
        overflow: false
    }, /* @__PURE__ */ React43.createElement(UitkTableBody2, null, /* @__PURE__ */ React43.createElement(React43.Fragment, null, hasData(mediaRow) && /* @__PURE__ */ React43.createElement(UitkTableRow2, null, mediaRow.map(function(section, index) {
        return /* @__PURE__ */ React43.createElement(UitkTableCell4, {
            key: getKey(index),
            border: [
                UitkTableCellBorder4.horizontal,
                UitkTableCellBorder4.vertical
            ],
            padding: UitkTableCellPadding3.zero
        }, section && /* @__PURE__ */ React43.createElement(LodgingCardMediaSection, {
            data: section,
            view: "RESPONSIVE" /* RESPONSIVE */ ,
            imageRatio: UitkFigureAspectRatioType5.R1_1
        }));
    })), compareRows.map(function(row, rowIndex) {
        if (!(row && hasData(row.cells))) {
            return null;
        }
        var Cell = rowIndex === 0 ? LodgingCompareCellHeader : LodgingCompareCell;
        return /* @__PURE__ */ React43.createElement(UitkTableRow2, {
            key: rowIndex
        }, row.cells.map(function(cell, index) {
            var key = getKey(index);
            return !cell ? /* @__PURE__ */ React43.createElement(UitkTableCell4, null) : /* @__PURE__ */ React43.createElement(Cell, {
                data: cell,
                key: key
            });
        }));
    }), hasData(viewRow) && /* @__PURE__ */ React43.createElement(UitkTableRow2, null, viewRow.map(function(buttonData, index) {
        return /* @__PURE__ */ React43.createElement(UitkTableCell4, {
            key: getKey(index),
            border: [
                UitkTableCellBorder4.horizontal,
                UitkTableCellBorder4.vertical
            ]
        }, buttonData && /* @__PURE__ */ React43.createElement(LodgingEGDSButton, {
            data: buttonData,
            isFullWidth: true
        }));
    })), hasData(removeRow) && /* @__PURE__ */ React43.createElement(UitkTableRow2, null, removeRow.map(function(removeData, index) {
        return /* @__PURE__ */ React43.createElement(UitkTableCell4, {
            align: {
                horizontal: "center"
            },
            key: getKey(index),
            border: [
                UitkTableCellBorder4.horizontal,
                UitkTableCellBorder4.vertical
            ]
        }, removeData && /* @__PURE__ */ React43.createElement(LodgingCompareRemoveAction, {
            data: removeData
        }));
    })))))))), /* @__PURE__ */ React43.createElement(UitkLayoutFlexItem4, {
        grow: 1
    }, /* @__PURE__ */ React43.createElement("div", null)));
};
LodgingCompareSection.fragment = fragment37;
LodgingCompareSection.displayName = "LodgingCompareSection";
// src/components/compare/__private/__fragments/lodging-error-response.tsx
import React44, { useCallback as useCallback5 } from "react";
import { gql as gql42 } from "@apollo/client";
import { useProvidedState as useProvidedState6 } from "@shared-ui/provided-state-context";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkText as UitkText9 } from "uitk-react-text";
var fragment38 = gql42(_templateObject41());
var LodgingErrorResponse = function(param) {
    var data = param.data;
    var button = data.button, header = data.header, body = data.body, errorRecoveryButtons = data.errorRecoveryButtons;
    var _useProvidedState6 = _slicedToArray(useProvidedState6(), 2), dispatch = _useProvidedState6[1];
    var closeDialog = useCallback5(function() {
        dispatch({
            type: CLOSE_DIALOG
        });
        window._qHasUsedPropertyCompare = true;
    }, [
        dispatch
    ]);
    var handlePrimaryButtonClick = useCallback5(function() {
        if (button.egdsElementId === "lodging-property-compare-error-button-close") {
            closeDialog();
        } else {
            window.location.reload();
        }
    }, [
        button.egdsElementId,
        closeDialog
    ]);
    return /* @__PURE__ */ React44.createElement(UitkLayoutFlex6, {
        justifyContent: "center",
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React44.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React44.createElement(UitkHeading2, {
        size: 5
    }, header)), /* @__PURE__ */ React44.createElement(UitkSpacing6, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React44.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React44.createElement(UitkText9, {
        size: 300,
        align: "center"
    }, body))), /* @__PURE__ */ React44.createElement(UitkSpacing6, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React44.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React44.createElement(LodgingEGDSButton, {
        data: button,
        isFullWidth: true,
        onClick: handlePrimaryButtonClick
    }))), (errorRecoveryButtons === null || errorRecoveryButtons === void 0 ? void 0 : errorRecoveryButtons[0]) ? /* @__PURE__ */ React44.createElement(UitkSpacing6, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React44.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React44.createElement(LodgingEGDSButton, {
        data: errorRecoveryButtons[0],
        onClick: closeDialog,
        isFullWidth: true
    }))) : null);
};
LodgingErrorResponse.fragment = fragment38;
LodgingErrorResponse.displayName = "LodgingErrorResponse";
// src/components/compare/__private/__fragments/compare-section.tsx
var __Query = gql43(_templateObject42(), LodgingCompareSection.fragment, LodgingCardMediaSection.fragment, LodgingCompareCell.fragment, LodgingCompareCellContent.fragment, LodgingEGDSRating.fragment, LodgingCardGuestRating.fragment, LodgingCompareTextItems.fragment, PriceSummaryFragment, LodgingCompareBadge.fragment, UiGraphic.fragment, LodgingEGDSIcon.fragment, LodgingEGDSButton.fragment, clientSideAnalyticsFragment, fragment2, LodgingCompareRemoveAction.fragment, LodgingErrorResponse.fragment);
var CompareSection = function(props) {
    var _data_propertyCompare;
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi2().context;
    var variables = useMemo5(function() {
        return _objectSpreadProps(_objectSpread({}, inputs), {
            context: context
        });
    }, []);
    var data = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }).data;
    var _data_propertyCompare_compareSection;
    var _ref = (_data_propertyCompare_compareSection = data === null || data === void 0 ? void 0 : (_data_propertyCompare = data.propertyCompare) === null || _data_propertyCompare === void 0 ? void 0 : _data_propertyCompare.compareSection) !== null && _data_propertyCompare_compareSection !== void 0 ? _data_propertyCompare_compareSection : {}, content = _ref.content, error = _ref.error;
    if (error) {
        return /* @__PURE__ */ React45.createElement(LodgingErrorResponse, {
            data: error
        });
    }
    if (content) {
        return /* @__PURE__ */ React45.createElement(LodgingCompareSection, {
            data: content
        });
    }
    return /* @__PURE__ */ React45.createElement(LodgingCompareLoading, null);
};
CompareSection.displayName = "PropertyCompare";
// src/components/compare/__private/__fragments/lodging-compare-dialog.tsx
var fragment39 = gql44(_templateObject43());
var LodgingCompareDialog = function(param) {
    var _param_data = param.data, closeAnalytics = _param_data.closeAnalytics, toolbar = _param_data.toolbar, inputs = param.inputs;
    var trackClose = useTrackClientSideAnalytics(closeAnalytics);
    var triggerRef = useRef(null);
    var _useDialog2 = _slicedToArray(useDialog2("lodging-compare-dialog", "compareDialog"), 3), hookIsOpen = _useDialog2[0], DialogActions = _useDialog2[1], DialogComponent = _useDialog2[2];
    var _useProvidedState7 = _slicedToArray(useProvidedState7(), 2), state = _useProvidedState7[0], dispatch = _useProvidedState7[1];
    var _state_STATE_FIELD_NAME;
    var _ref = (_state_STATE_FIELD_NAME = state[STATE_FIELD_NAME]) !== null && _state_STATE_FIELD_NAME !== void 0 ? _state_STATE_FIELD_NAME : defaultState, stateIsOpen = _ref.isDialogOpen, comparePropertyIds = _ref.comparePropertyIds;
    var isOpen = useRef(false);
    useEffect(function() {
        if (stateIsOpen !== isOpen.current) {
            if (stateIsOpen) {
                DialogActions.openDialog();
            } else {
                trackClose();
                DialogActions.closeDialog();
            }
            isOpen.current = stateIsOpen;
        } else if (hookIsOpen !== isOpen.current) {
            dispatch({
                type: hookIsOpen ? OPEN_DIALOG : CLOSE_DIALOG
            });
            isOpen.current = hookIsOpen;
        }
    }, [
        stateIsOpen,
        hookIsOpen
    ]);
    useEffect(function() {
        if (isOpen.current) {
            dispatch({
                type: comparePropertyIds.length === 0 ? CLOSE_DIALOG : OPEN_DIALOG
            });
        }
    }, [
        comparePropertyIds
    ]);
    var closeDialog = useCallback6(function() {
        dispatch({
            type: CLOSE_DIALOG
        });
        window._qHasUsedPropertyCompare = true;
    }, [
        dispatch
    ]);
    var _toolbar_closeText;
    return /* @__PURE__ */ React46.createElement(DialogComponent, null, /* @__PURE__ */ React46.createElement(UitkSheet2, {
        isVisible: true,
        type: "full",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React46.createElement(UitkToolbar, {
        toolbarTitle: toolbar.title,
        navigationContent: {
            onClick: closeDialog,
            navIconLabel: (_toolbar_closeText = toolbar.closeText) !== null && _toolbar_closeText !== void 0 ? _toolbar_closeText : void 0
        }
    }), /* @__PURE__ */ React46.createElement(UitkSheetContent2, {
        padded: false
    }, /* @__PURE__ */ React46.createElement(UitkSpacing7, {
        padding: {
            block: "six"
        }
    }, /* @__PURE__ */ React46.createElement("div", null, /* @__PURE__ */ React46.createElement(CompareSection, {
        inputs: _objectSpreadProps(_objectSpread({}, inputs), {
            propertyIds: comparePropertyIds
        })
    }))))));
};
LodgingCompareDialog.fragment = fragment39;
LodgingCompareDialog.displayName = "LodgingCompareDialog";
// src/components/compare/property-compare.tsx
var __Query2 = gql45(_templateObject44(), LodgingCompareActionSheet.fragment, LodgingEGDSSheet.fragment, clientSideAnalyticsFragment, LodgingEGDSCardinalLocalizedText.fragment, LodgingEGDSIcon.fragment, LodgingEGDSButton.fragment, LodgingCompareDialog.fragment, fragment2);
var PropertyCompare = function(props) {
    var _data_propertyCompare;
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi3().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery2 = useQuery2(__Query2, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : (_data_propertyCompare = data.propertyCompare) === null || _data_propertyCompare === void 0 ? void 0 : _data_propertyCompare.actionSheet) || !data.propertyCompare.dialog) {
        return null;
    }
    return /* @__PURE__ */ React47.createElement(React47.Fragment, null, /* @__PURE__ */ React47.createElement(LodgingCompareActionSheet, {
        data: data.propertyCompare.actionSheet
    }), /* @__PURE__ */ React47.createElement(LodgingCompareDialog, {
        data: data.propertyCompare.dialog,
        inputs: inputs
    }));
};
PropertyCompare.displayName = "PropertyCompare";
// src/components/compare/lodging-compare-state-manager.tsx
import React48, { useEffect as useEffect2, useMemo as useMemo6, useRef as useRef2 } from "react";
import { useHistory as useHistory2, useLocation } from "react-router-dom";
import { useProvidedState as useProvidedState8 } from "@shared-ui/provided-state-context";
var parsePropertyIds = function(parameter) {
    return (parameter !== null && parameter !== void 0 ? parameter : "").split(",").filter(function(param) {
        var length = param.length;
        return length !== 0;
    });
};
var LodgingCompareStateManager = function(param) {
    var searchResultsProperties = param.searchResultsProperties, children = param.children;
    var _useProvidedState8 = _slicedToArray(useProvidedState8(), 2), state = _useProvidedState8[0], dispatch = _useProvidedState8[1];
    var _state_STATE_FIELD_NAME;
    var comparePropertyIds = ((_state_STATE_FIELD_NAME = state[STATE_FIELD_NAME]) !== null && _state_STATE_FIELD_NAME !== void 0 ? _state_STATE_FIELD_NAME : defaultState).comparePropertyIds;
    var location = useLocation();
    var history = useHistory2();
    useEffect2(function() {
        return dispatch({
            type: SET_PROPERTIES,
            payload: {
                searchResultsProperties: searchResultsProperties
            }
        });
    }, [
        searchResultsProperties
    ]);
    var initialized = useRef2(false);
    var searchParams = useMemo6(function() {
        return new URLSearchParams(location.search);
    }, [
        location.search
    ]);
    var propertyIdSearchParam = searchParams.get(COMPARE_PROPERTY_IDS_QUERY_PARAMETER);
    useEffect2(function() {
        if (!searchResultsProperties.length) {
            return;
        }
        if (!initialized.current) {
            var propertyIds = parsePropertyIds(propertyIdSearchParam);
            propertyIds.forEach(function(propertyId) {
                return dispatch({
                    type: ADD_COMPARE_PROPERTY,
                    payload: {
                        propertyId: propertyId
                    }
                });
            });
            initialized.current = true;
            return;
        }
        var searchPropertyIds = parsePropertyIds(propertyIdSearchParam);
        if (comparePropertyIds.join(",") !== searchPropertyIds.join(",")) {
            if (comparePropertyIds.length === 0) {
                searchParams.delete(COMPARE_PROPERTY_IDS_QUERY_PARAMETER);
            } else {
                searchParams.set(COMPARE_PROPERTY_IDS_QUERY_PARAMETER, comparePropertyIds.join(","));
            }
            history.replace({
                pathname: location.pathname,
                hash: location.hash,
                state: location.state,
                search: searchParams.toString()
            });
        }
    }, [
        comparePropertyIds,
        searchResultsProperties,
        propertyIdSearchParam
    ]);
    return /* @__PURE__ */ React48.createElement(React48.Fragment, null, children);
};
// src/components/compare/utilities.ts
var getCardId = function(property) {
    return isAd(property.mediaSection) ? property.id.concat("-ad") : property.id;
};
// src/components/compare/lodging-compare-state-chunk.ts
var update = function(event, state, eventData) {
    switch(event){
        case SET_PROPERTIES:
            {
                var searchResultsProperties = eventData.data.searchResultsProperties;
                return _objectSpreadProps(_objectSpread({}, state), {
                    searchResultsProperties: searchResultsProperties,
                    comparePropertyIds: searchResultsProperties.length ? state.comparePropertyIds : defaultState.comparePropertyIds
                });
            }
        case ADD_COMPARE_PROPERTY:
            {
                var propertyId = eventData.data.propertyId;
                var property = state.searchResultsProperties.find(function(p) {
                    return getCardId(p) === propertyId;
                });
                if (!property) {
                    return state;
                }
                return _objectSpreadProps(_objectSpread({}, state), {
                    comparePropertyIds: _toConsumableArray(state.comparePropertyIds).concat([
                        propertyId
                    ])
                });
            }
        case REMOVE_COMPARE_PROPERTY:
            {
                var comparePropertyIds = state.comparePropertyIds.filter(function(id) {
                    var _eventData_data = eventData.data, cardId = _eventData_data.propertyId;
                    return getPropertyIdFromCardId(id) !== getPropertyIdFromCardId(cardId);
                });
                return _objectSpreadProps(_objectSpread({}, state), {
                    comparePropertyIds: comparePropertyIds
                });
            }
        case OPEN_DIALOG:
            return _objectSpreadProps(_objectSpread({}, state), {
                isDialogOpen: true
            });
        case CLOSE_DIALOG:
            return _objectSpreadProps(_objectSpread({}, state), {
                isDialogOpen: false
            });
        default:
            return state;
    }
};
var LodgingCompareStateChunk = {
    data: defaultState,
    stateFieldName: STATE_FIELD_NAME,
    events: events,
    update: update
};
// src/components/experimental/compare-selection-adaptex.tsx
import React50, { useContext as useContext2, useEffect as useEffect4, useMemo as useMemo7 } from "react";
import { gql as gql46, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { ITrackType as ITrackType5, useClickstreamAnalytics as useClickstreamAnalytics4 } from "@shared-ui/clickstream-analytics-context";
import { CompareAdaptExContext as CompareAdaptExContext2, defaultState as defaultAdaptExState, SHOW_PROMPT as SHOW_PROMPT2, SHOW_PROMPT_YES as SHOW_PROMPT_YES2, TICK_BOX_VISIBILITY as TICK_BOX_VISIBILITY2, TICK_BOX_VISIBILITY_TRUE as TICK_BOX_VISIBILITY_TRUE2, TOGGLE_PLACEMENT as TOGGLE_PLACEMENT2, TOGGLE_PLACEMENT_NONE as TOGGLE_PLACEMENT_NONE2, TOGGLE_PLACEMENT_SRP } from "@shared-ui/retail-compare-providers";
// src/components/experimental/lodging-compare-prompt.tsx
import React49, { useCallback as useCallback7, useContext, useEffect as useEffect3, useRef as useRef3 } from "react";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { useLocalization } from "@shared-ui/localization-context";
import { CompareAdaptExContext, SHOW_PROMPT, SHOW_PROMPT_YES, TICK_BOX_VISIBILITY, TICK_BOX_VISIBILITY_FALSE, TICK_BOX_VISIBILITY_TRUE, TOGGLE_PLACEMENT, TOGGLE_PLACEMENT_NONE } from "@shared-ui/retail-compare-providers";
import { ViewLarge, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkPrimaryButton as UitkPrimaryButton2, UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
import { UitkIcon as UitkIcon7, UitkIconSize as UitkIconSize6 } from "uitk-react-icons";
import { UitkIllustrations as UitkIllustrations2 } from "uitk-react-illustrations";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet3, UitkSheetCloseButton, UitkSheetContent as UitkSheetContent3 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkText as UitkText10 } from "uitk-react-text";
import { UitkToolbar as UitkToolbar2 } from "uitk-react-toolbar";
var _obj8;
var descriptions = (_obj8 = {}, _defineProperty(_obj8, TICK_BOX_VISIBILITY_TRUE, "hotels.searchResults.comparison.compare.prompt.description.on"), _defineProperty(_obj8, TICK_BOX_VISIBILITY_FALSE, "hotels.searchResults.comparison.compare.prompt.description.off"), _obj8);
var _obj9;
var primaryButtonLabels = (_obj9 = {}, _defineProperty(_obj9, TICK_BOX_VISIBILITY_TRUE, "hotels.searchResults.comparison.compare.prompt.primaryAction.on"), _defineProperty(_obj9, TICK_BOX_VISIBILITY_FALSE, "hotels.searchResults.comparison.compare.prompt.primaryAction.off"), _obj9);
var _obj10;
var tertiaryButtonLabels = (_obj10 = {}, _defineProperty(_obj10, TICK_BOX_VISIBILITY_TRUE, "hotels.searchResults.comparison.compare.prompt.alternateAction.on"), _defineProperty(_obj10, TICK_BOX_VISIBILITY_FALSE, "hotels.searchResults.comparison.compare.prompt.alternateAction.off"), _obj10);
var buttonAction = function(status, button) {
    if (button === "primary" && status === "off") {
        return "enable";
    }
    if (button === "secondary" && status === "on") {
        return "disable";
    }
    return "dismiss";
};
var trackToggleParameters = function(visibility, button) {
    var status = visibility === TICK_BOX_VISIBILITY_TRUE ? "on" : "off";
    var action = buttonAction(status, button);
    return [
        "HOT.SR.PROPERTY.COMPARISON.prompt.toggle.".concat(status, ".").concat(action, ".click"),
        "Comparison prompt toggle ".concat(status, " ").concat(action, " click")
    ];
};
var LodgingComparePrompt = function() {
    var track = useClickTracker5();
    var ctaClose = useRef3(false);
    var _useContext = _slicedToArray(useContext(CompareAdaptExContext), 2), state = _useContext[0], setState = _useContext[1];
    var _state_arms = state.arms, togglePlacement = _state_arms[TOGGLE_PLACEMENT], tickBoxVisibility = _state_arms[TICK_BOX_VISIBILITY], showPrompt = _state_arms[SHOW_PROMPT];
    var ref = useRef3(null);
    var trackClose = useCallback7(function() {
        if (ctaClose.current) {
            return;
        }
        if (togglePlacement === TOGGLE_PLACEMENT_NONE) {
            track("HOT.SR.PROPERTY.COMPARISON.prompt.tickbox.close.click", "Comparison prompt tick box close click");
        } else {
            var status = state.enabled ? "on" : "off";
            track("HOT.SR.PROPERTY.COMPARISON.prompt.toggle.".concat(status, ".close.click"), "Comparison prompt toggle ".concat(status, " close click"));
        }
    }, [
        state
    ]);
    var _useDialog3 = _slicedToArray(useDialog3("comparePrompt", "comparePromptDialog", void 0, trackClose), 3), _useDialog3_ = _useDialog3[1], openDialog = _useDialog3_.openDialog, closeDialog = _useDialog3_.closeDialog, Dialog = _useDialog3[2];
    var handleCloseClick = useCallback7(function() {
        closeDialog();
    }, [
        closeDialog
    ]);
    var handlePrimaryButtonClick = useCallback7(function() {
        setState(_objectSpreadProps(_objectSpread({}, state), {
            enabled: true
        }));
        ctaClose.current = true;
        closeDialog();
        if (togglePlacement === TOGGLE_PLACEMENT_NONE) {
            track("HOT.SR.PROPERTY.COMPARISON.prompt.tickbox.dismiss.click", "Comparison prompt tick box dismiss click");
        } else {
            track.apply(void 0, _toConsumableArray(trackToggleParameters(tickBoxVisibility, "primary")));
        }
    }, [
        state
    ]);
    var handleSecondaryButtonClick = useCallback7(function() {
        setState(_objectSpreadProps(_objectSpread({}, state), {
            enabled: false
        }));
        ctaClose.current = true;
        closeDialog();
        track.apply(void 0, _toConsumableArray(trackToggleParameters(tickBoxVisibility, "secondary")));
    }, [
        state
    ]);
    useEffect3(function() {
        if (showPrompt === SHOW_PROMPT_YES) {
            ctaClose.current = false;
            openDialog();
        }
    }, [
        state.arms
    ]);
    var formatText = useLocalization().formatText;
    var tertiaryButtonLabel = togglePlacement === TOGGLE_PLACEMENT_NONE ? null : formatText(tertiaryButtonLabels[tickBoxVisibility]);
    var closeLabel = formatText("hotels.searchResults.comparison.compare.prompt.close.a11y");
    var sheetContent = /* @__PURE__ */ React49.createElement(React49.Fragment, null, /* @__PURE__ */ React49.createElement(UitkLayoutFlex7, {
        justifyContent: "center"
    }, /* @__PURE__ */ React49.createElement(UitkLayoutFlexItem6, {
        maxWidth: "24x"
    }, /* @__PURE__ */ React49.createElement(UitkIllustrations2, {
        alt: "",
        url: "https://a.travel-assets.com/travel-assets-manager/957c8206-d529-4904-92fd-37b3e3fd1c4b/lodging-compare-prompt.svg"
    }))), /* @__PURE__ */ React49.createElement(UitkSpacing8, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React49.createElement(UitkHeading3, {
        size: 4,
        align: "center"
    }, formatText("hotels.searchResults.comparison.compare.prompt.heading"))), /* @__PURE__ */ React49.createElement(UitkSpacing8, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React49.createElement(UitkText10, {
        align: "center"
    }, formatText(descriptions[tickBoxVisibility]))), /* @__PURE__ */ React49.createElement(UitkSpacing8, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React49.createElement(UitkPrimaryButton2, {
        onClick: handlePrimaryButtonClick,
        isFullWidth: true
    }, formatText(primaryButtonLabels[tickBoxVisibility]))), tertiaryButtonLabel && /* @__PURE__ */ React49.createElement(UitkSpacing8, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React49.createElement(UitkTertiaryButton2, {
        onClick: handleSecondaryButtonClick,
        isFullWidth: true
    }, tertiaryButtonLabel)));
    return /* @__PURE__ */ React49.createElement(Dialog, null, /* @__PURE__ */ React49.createElement(Viewport2, null, /* @__PURE__ */ React49.createElement(ViewSmall2, null, /* @__PURE__ */ React49.createElement(UitkSheet3, {
        type: "bottom",
        isVisible: true,
        triggerRef: ref,
        hasModal: true
    }, /* @__PURE__ */ React49.createElement(UitkSheetCloseButton, {
        alignment: "top"
    }, /* @__PURE__ */ React49.createElement(UitkTertiaryButton2, {
        type: "button",
        onClick: handleCloseClick
    }, /* @__PURE__ */ React49.createElement(UitkIcon7, {
        name: "close",
        size: UitkIconSize6.MEDIUM,
        title: closeLabel
    }))), /* @__PURE__ */ React49.createElement(UitkSheetContent3, {
        padded: false
    }, /* @__PURE__ */ React49.createElement(UitkSpacing8, {
        padding: {
            blockend: "six",
            inline: "six"
        }
    }, /* @__PURE__ */ React49.createElement("div", null, sheetContent))))), /* @__PURE__ */ React49.createElement(ViewLarge, null, /* @__PURE__ */ React49.createElement(UitkSheet3, {
        type: "centered",
        isVisible: true,
        triggerRef: ref,
        centeredSheetSize: "small"
    }, /* @__PURE__ */ React49.createElement(UitkToolbar2, {
        navigationContent: {
            onClick: handleCloseClick,
            navIconLabel: closeLabel
        }
    }), /* @__PURE__ */ React49.createElement(UitkSheetContent3, null, sheetContent)))));
};
// src/components/experimental/use-impression-tracker.ts
import { ITrackType as ITrackType4, useClickstreamAnalytics as useClickstreamAnalytics3 } from "@shared-ui/clickstream-analytics-context";
var useImpressionTracker = function() {
    var track = useClickstreamAnalytics3().track;
    return function(referrerId, linkName) {
        track(ITrackType4.EVENT, {
            data: {
                schemaName: "referrer",
                messageContent: {
                    referrerId: referrerId,
                    linkName: linkName,
                    eventType: "impression"
                }
            }
        });
    };
};
// src/components/experimental/compare-selection-adaptex.tsx
var __Query3 = gql46(_templateObject45());
var defaultState2 = {
    userSawPrompt: false,
    userSawToggleOrTickBox: false
};
var STORAGE_KEY = "compareSelectionAdaptEx";
var storage = typeof window === "undefined" ? {
    getItem: function() {
        return null;
    }
} : window.localStorage;
var serializedDefault = JSON.stringify(defaultState2);
var yesOrNo = function(isTrue) {
    return isTrue ? "yes" : "no";
};
var CompareSelectionAdaptEx = function(props) {
    var _inputs_criteria, _inputs_criteria_primary;
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi4().context;
    var _JSON_parse = JSON.parse(storage.getItem(STORAGE_KEY) || serializedDefault), userSawPrompt = _JSON_parse.userSawPrompt, userSawToggleOrTickBox = _JSON_parse.userSawToggleOrTickBox;
    var variables = useMemo7(function() {
        return _objectSpreadProps(_objectSpread({}, inputs), {
            context: context,
            stateContext: {
                state: [
                    {
                        name: "user-saw-prompt",
                        value: yesOrNo(userSawPrompt)
                    },
                    {
                        name: "user-saw-toggle-or-tick-box",
                        value: yesOrNo(userSawToggleOrTickBox)
                    }
                ]
            }
        });
    }, [
        JSON.stringify((_inputs_criteria = inputs.criteria) === null || _inputs_criteria === void 0 ? void 0 : (_inputs_criteria_primary = _inputs_criteria.primary) === null || _inputs_criteria_primary === void 0 ? void 0 : _inputs_criteria_primary.dateRange),
        inputs.shoppingContext
    ]);
    var data = useQuery3(__Query3, {
        variables: variables,
        ssr: !skipSsr
    }).data;
    var _useContext2 = _slicedToArray(useContext2(CompareAdaptExContext2), 2), adaptExContext = _useContext2[0], setAdaptExContext = _useContext2[1];
    var _data_propertyCompare;
    var compareSelectionAdaptEx = ((_data_propertyCompare = data === null || data === void 0 ? void 0 : data.propertyCompare) !== null && _data_propertyCompare !== void 0 ? _data_propertyCompare : {}).compareSelectionAdaptEx;
    var trackImpression = useImpressionTracker();
    useEffect4(function() {
        if (compareSelectionAdaptEx) {
            var armsList = compareSelectionAdaptEx.arms, campaignId2 = compareSelectionAdaptEx.campaignId, payloadId2 = compareSelectionAdaptEx.payloadId;
            var arms = armsList.reduce(function(acc, param) {
                var name = param.name, level = param.level;
                return _objectSpreadProps(_objectSpread({}, acc), _defineProperty({}, name, level));
            }, adaptExContext.arms);
            var tickBoxVisibility = arms[TICK_BOX_VISIBILITY2], togglePlacement = arms[TOGGLE_PLACEMENT2], showPrompt = arms[SHOW_PROMPT2];
            var enabled = tickBoxVisibility === TICK_BOX_VISIBILITY_TRUE2;
            setAdaptExContext({
                campaignId: campaignId2,
                payloadId: payloadId2,
                arms: arms,
                enabled: enabled
            });
            var persistedState = {
                userSawPrompt: userSawPrompt || showPrompt === SHOW_PROMPT_YES2,
                userSawToggleOrTickBox: userSawToggleOrTickBox || togglePlacement !== TOGGLE_PLACEMENT_NONE2 || tickBoxVisibility === TICK_BOX_VISIBILITY_TRUE2
            };
            storage.setItem(STORAGE_KEY, JSON.stringify(persistedState));
            var status = enabled ? "on" : "off";
            if (togglePlacement !== TOGGLE_PLACEMENT_NONE2) {
                var section = togglePlacement === TOGGLE_PLACEMENT_SRP ? "SR" : "SFP";
                trackImpression("HOT.".concat(section, ".PROPERTY.COMPARISON.toggle.display.").concat(status), "Comparison toggle ".concat(section, " display ").concat(status));
            }
            if (showPrompt === SHOW_PROMPT_YES2) {
                if (togglePlacement === TOGGLE_PLACEMENT_NONE2) {
                    trackImpression("HOT.SR.PROPERTY.COMPARISON.prompt.display.tickbox", "Comparison prompt display tick box");
                } else {
                    trackImpression("HOT.SR.PROPERTY.COMPARISON.prompt.display.toggle.".concat(status), "Comparison prompt display toggle ".concat(status));
                }
            }
        } else {
            setAdaptExContext(defaultAdaptExState);
        }
    }, [
        compareSelectionAdaptEx
    ]);
    var _ref = compareSelectionAdaptEx !== null && compareSelectionAdaptEx !== void 0 ? compareSelectionAdaptEx : {}, campaignId = _ref.campaignId, payloadId = _ref.payloadId;
    var track = useClickstreamAnalytics4().track;
    useEffect4(function() {
        if (campaignId && payloadId) {
            track(ITrackType5.EVENT, {
                data: lightweightAdaptExMicroMessage({
                    campaignId: campaignId,
                    payloadId: payloadId,
                    eventType: "load",
                    eventTarget: "srp"
                })
            });
        }
    }, [
        payloadId
    ]);
    return /* @__PURE__ */ React50.createElement(LodgingComparePrompt, null);
};
CompareSelectionAdaptEx.displayName = "CompareSelectionAdaptEx";
// src/components/experimental/lodging-compare-sheet/lodging-compare-sheet.tsx
import React65, { useContext as useContext4, useEffect as useEffect6 } from "react";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { useProvidedState as useProvidedState13 } from "@shared-ui/provided-state-context";
import { CompareAdaptExContext as CompareAdaptExContext4 } from "@shared-ui/retail-compare-providers";
import { TripsToastStateEvents } from "@shared-ui/trips-save-item";
import { UitkButtonSize as UitkButtonSize2, UitkPrimaryButton as UitkPrimaryButton4 } from "uitk-react-button";
import { UitkCard as UitkCard2 } from "uitk-react-cards";
import { UitkIcon as UitkIcon8 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex10, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid5, UitkLayoutGridItem as UitkLayoutGridItem5 } from "uitk-react-layout-grid";
import { UitkSheet as UitkSheet5, UitkSheetContent as UitkSheetContent4 } from "uitk-react-sheet";
import { UitkText as UitkText14 } from "uitk-react-text";
// src/components/experimental/lodging-compare-dialog/lodging-compare-dialog.tsx
import React64, { useCallback as useCallback9, useEffect as useEffect5, useRef as useRef4 } from "react";
import { useHistory as useHistory3, useLocation as useLocation2 } from "react-router-dom";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { useProvidedState as useProvidedState12 } from "@shared-ui/provided-state-context";
import { UitkDialogContent as UitkDialogContent2 } from "uitk-react-dialog";
import { UitkSheet as UitkSheet4 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar3 } from "uitk-react-toolbar";
// src/components/experimental/lodging-compare-table/lodging-compare-table.tsx
import React63, { useMemo as useMemo9 } from "react";
import { useProvidedState as useProvidedState11 } from "@shared-ui/provided-state-context";
import { UitkLayoutFlex as UitkLayoutFlex9, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
import { UitkTable as UitkTable3, UitkTableBody as UitkTableBody3 } from "uitk-react-tables";
// src/components/experimental/lodging-compare-table/lodging-compare-table-amenities.tsx
import React52 from "react";
// ../internal/src/components/lodging-card/__private/lodging-product-amenity.tsx
import React51 from "react";
import { gql as gql47 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex8 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkText as UitkText11 } from "uitk-react-text";
var fragment40 = gql47(_templateObject46(), LodgingEGDSIcon.fragment);
var LodgingProductAmenity = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React51.createElement(UitkSpacing9, {
        margin: {
            inlineend: "three"
        },
        padding: {
            block: "one"
        }
    }, /* @__PURE__ */ React51.createElement(UitkLayoutFlex8, {
        space: "two",
        alignItems: "center"
    }, /* @__PURE__ */ React51.createElement(LodgingEGDSIcon, {
        ariaHidden: true,
        data: data.icon
    }), /* @__PURE__ */ React51.createElement(UitkText11, {
        size: 200,
        overflow: "truncate"
    }, data.text)));
};
LodgingProductAmenity.fragment = fragment40;
LodgingProductAmenity.displayName = "LodgingProductAmenity";
// src/components/experimental/lodging-compare-table/lodging-compare-table-amenities.tsx
import { UitkTableCell as UitkTableCell5, UitkTableCellBorder as UitkTableCellBorder5, UitkTableRow as UitkTableRow3 } from "uitk-react-tables";
function LodgingCompareTableAmenities(param) {
    var compareProperties = param.compareProperties;
    return /* @__PURE__ */ React52.createElement(UitkTableRow3, null, compareProperties.map(function(property) {
        var _property_headingSection, _property_headingSection_amenities;
        /* @__PURE__ */ return React52.createElement(UitkTableCell5, {
            border: [
                UitkTableCellBorder5.horizontal,
                UitkTableCellBorder5.vertical
            ],
            key: property.id
        }, (_property_headingSection = property.headingSection) === null || _property_headingSection === void 0 ? void 0 : (_property_headingSection_amenities = _property_headingSection.amenities) === null || _property_headingSection_amenities === void 0 ? void 0 : _property_headingSection_amenities.map(function(amenity, amenityIndex) {
            return /* @__PURE__ */ React52.createElement(LodgingProductAmenity, {
                data: amenity,
                key: "amenity-".concat(amenityIndex)
            });
        }));
    }));
}
// src/components/experimental/lodging-compare-table/lodging-compare-table-flex-search-dates.tsx
import React53 from "react";
import { UitkTableCell as UitkTableCell6, UitkTableCellBorder as UitkTableCellBorder6, UitkTableRow as UitkTableRow4 } from "uitk-react-tables";
var LodgingCompareTableFlexSearchDates = function(param) {
    var compareProperties = param.compareProperties;
    return /* @__PURE__ */ React53.createElement(UitkTableRow4, null, compareProperties.map(function(property) {
        var _property_dateSection;
        /* @__PURE__ */ return React53.createElement(UitkTableCell6, {
            border: [
                UitkTableCellBorder6.horizontal,
                UitkTableCellBorder6.vertical
            ],
            key: property.id
        }, ((_property_dateSection = property.dateSection) === null || _property_dateSection === void 0 ? void 0 : _property_dateSection.date) && /* @__PURE__ */ React53.createElement(EGDSStylizedText, {
            data: _objectSpreadProps(_objectSpread({}, property.dateSection.date), {
                size: "200"
            })
        }));
    }));
};
// src/components/experimental/lodging-compare-table/lodging-compare-table-guest-rating.tsx
import React54, { Fragment } from "react";
import { UitkTableCell as UitkTableCell7, UitkTableCellBorder as UitkTableCellBorder7, UitkTableRow as UitkTableRow5 } from "uitk-react-tables";
function LodgingCompareTableGuestRating(param) {
    var compareProperties = param.compareProperties;
    return /* @__PURE__ */ React54.createElement(UitkTableRow5, null, compareProperties.map(function(property) {
        /* @__PURE__ */ return React54.createElement(UitkTableCell7, {
            border: [
                UitkTableCellBorder7.horizontal,
                UitkTableCellBorder7.vertical
            ],
            key: property.id
        }, property.summarySections.map(function(summary, guestRatingIndex) {
            var _summary_guestRating;
            var _summary_guestRating_parts_map;
            var guestRatingParts = (_summary_guestRating_parts_map = (_summary_guestRating = summary.guestRating) === null || _summary_guestRating === void 0 ? void 0 : _summary_guestRating.parts.map(function(part) {
                if (part.__typename === "EGDSStylizedText") {
                    return _objectSpreadProps(_objectSpread({}, part), {
                        size: "200"
                    });
                }
                return part;
            })) !== null && _summary_guestRating_parts_map !== void 0 ? _summary_guestRating_parts_map : [];
            var guestRating = summary.guestRating ? _objectSpreadProps(_objectSpread({}, summary.guestRating), {
                parts: guestRatingParts
            }) : void 0;
            return /* @__PURE__ */ React54.createElement(Fragment, {
                key: guestRatingIndex
            }, guestRating && /* @__PURE__ */ React54.createElement(LodgingCardGuestRating, {
                data: guestRating,
                size: 200
            }));
        }));
    }));
}
// src/components/experimental/lodging-compare-table/lodging-compare-table-heading.tsx
import React55 from "react";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutGrid as UitkLayoutGrid4, UitkLayoutGridItem as UitkLayoutGridItem4 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
import { UitkTableCell as UitkTableCell8, UitkTableCellBorder as UitkTableCellBorder8, UitkTableCellHeaderScope as UitkTableCellHeaderScope2, UitkTableCellPadding as UitkTableCellPadding4, UitkTableCellTag as UitkTableCellTag2, UitkTableRow as UitkTableRow6 } from "uitk-react-tables";
import { UitkText as UitkText12 } from "uitk-react-text";
// src/components/experimental/utilities.ts
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
function useFormattedText() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var formatText = useLocalization2().formatText;
    var fallbackText = args.pop();
    var text = formatText.apply(this, args);
    if (!text || text.startsWith("formatText is not supported")) {
        return fallbackText;
    }
    return text;
}
var getRfrr = function(rfrr, property) {
    return isAd(property.mediaSection) ? rfrr.concat(".ad") : rfrr;
};
// src/components/experimental/lodging-compare-table/lodging-compare-table-heading.tsx
function LodgingCompareTableHeading(param) {
    var compareProperties = param.compareProperties;
    return /* @__PURE__ */ React55.createElement(UitkTableRow6, null, compareProperties.map(function(property, headingIndex) {
        var _property_headingSection;
        var rfrr = "HOT.SR.PROPERTY.COMPARISON.property.".concat(headingIndex + 1, ".impression");
        return /* @__PURE__ */ React55.createElement(UitkTableCell8, {
            scope: UitkTableCellHeaderScope2.column,
            border: [
                UitkTableCellBorder8.horizontal,
                UitkTableCellBorder8.vertical
            ],
            tag: UitkTableCellTag2.header,
            padding: UitkTableCellPadding4.zero,
            key: property.id
        }, /* @__PURE__ */ React55.createElement(UitkLayoutGrid4, {
            columns: [
                "48x"
            ]
        }, /* @__PURE__ */ React55.createElement(UitkLayoutGridItem4, null, /* @__PURE__ */ React55.createElement(UitkSpacing10, {
            padding: "three"
        }, /* @__PURE__ */ React55.createElement(IntersectionTracker2, {
            referrerId: getRfrr(rfrr, property),
            linkName: "Comparison table column impression"
        }, /* @__PURE__ */ React55.createElement(UitkText12, {
            whiteSpace: "normal",
            weight: "medium"
        }, (_property_headingSection = property.headingSection) === null || _property_headingSection === void 0 ? void 0 : _property_headingSection.heading))))));
    }));
}
// src/components/experimental/lodging-compare-table/lodging-compare-table-media.tsx
import React56 from "react";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType6 } from "uitk-react-images";
import { UitkTableCell as UitkTableCell9, UitkTableCellBorder as UitkTableCellBorder9, UitkTableCellPadding as UitkTableCellPadding5, UitkTableRow as UitkTableRow7 } from "uitk-react-tables";
function LodgingCompareTableMedia(param) {
    var compareProperties = param.compareProperties;
    return /* @__PURE__ */ React56.createElement(UitkTableRow7, null, compareProperties.map(function(property) {
        return /* @__PURE__ */ React56.createElement(UitkTableCell9, {
            border: [
                UitkTableCellBorder9.horizontal,
                UitkTableCellBorder9.vertical
            ],
            padding: UitkTableCellPadding5.zero,
            key: property.id
        }, /* @__PURE__ */ React56.createElement(LodgingCardMediaSection, {
            data: _objectSpreadProps(_objectSpread({}, property.mediaSection), {
                badges: null
            }),
            cardLink: property.cardLink,
            propertyId: property.id,
            view: "RESPONSIVE" /* RESPONSIVE */ ,
            imageRatio: UitkFigureAspectRatioType6.R1_1
        }));
    }));
}
// src/components/experimental/lodging-compare-table/lodging-compare-table-messages.tsx
import React57 from "react";
import { UitkTableCell as UitkTableCell10, UitkTableCellBorder as UitkTableCellBorder10, UitkTableRow as UitkTableRow8 } from "uitk-react-tables";
function LodgingCompareTableMessages(param) {
    var compareProperties = param.compareProperties;
    return /* @__PURE__ */ React57.createElement(UitkTableRow8, null, compareProperties.map(function(property) {
        var _property_headingSection;
        /* @__PURE__ */ return React57.createElement(UitkTableCell10, {
            border: [
                UitkTableCellBorder10.horizontal,
                UitkTableCellBorder10.vertical
            ],
            key: property.id
        }, (_property_headingSection = property.headingSection) === null || _property_headingSection === void 0 ? void 0 : _property_headingSection.messages.map(function(message, messageIndex) {
            return /* @__PURE__ */ React57.createElement(LodgingEGDSText, {
                overflow: "truncate-2-lines",
                spacing: "half",
                size: 200,
                data: message,
                key: "message-".concat(messageIndex)
            });
        }));
    }));
}
// src/components/experimental/lodging-compare-table/lodging-compare-table-price.tsx
import React58 from "react";
import { UitkPriceLockupAlign as UitkPriceLockupAlign3 } from "uitk-react-price-lockup";
import { UitkTableCell as UitkTableCell11, UitkTableCellBorder as UitkTableCellBorder11, UitkTableRow as UitkTableRow9 } from "uitk-react-tables";
import { UitkText as UitkText13 } from "uitk-react-text";
function LodgingCompareTablePrice(param) {
    var compareProperties = param.compareProperties;
    return /* @__PURE__ */ React58.createElement(UitkTableRow9, null, /* @__PURE__ */ React58.createElement(React58.Fragment, null, compareProperties.map(function(property) {
        var _priceSection_badge, _priceSection_standardBadge, _property_priceSection;
        var priceSection = property.priceSection;
        if (!priceSection) {
            return /* @__PURE__ */ React58.createElement(UitkTableCell11, {
                border: [
                    UitkTableCellBorder11.horizontal,
                    UitkTableCellBorder11.vertical
                ],
                key: property.id
            });
        }
        var badgeText = ((_priceSection_badge = priceSection.badge) === null || _priceSection_badge === void 0 ? void 0 : _priceSection_badge.text) || ((_priceSection_standardBadge = priceSection.standardBadge) === null || _priceSection_standardBadge === void 0 ? void 0 : _priceSection_standardBadge.standardBadge.text);
        return /* @__PURE__ */ React58.createElement(UitkTableCell11, {
            align: {
                vertical: "bottom"
            },
            border: [
                UitkTableCellBorder11.horizontal,
                UitkTableCellBorder11.vertical
            ],
            key: property.id
        }, ((_property_priceSection = property.priceSection) === null || _property_priceSection === void 0 ? void 0 : _property_priceSection.priceSummary) && /* @__PURE__ */ React58.createElement(React58.Fragment, null, badgeText && /* @__PURE__ */ React58.createElement(UitkText13, {
            overflow: "wrap",
            size: 200,
            weight: "medium",
            theme: "emphasis"
        }, badgeText), /* @__PURE__ */ React58.createElement(PriceSectionPriceSummary, {
            priceSection: priceSection,
            align: UitkPriceLockupAlign3.LEFT,
            flexAlignment: "start"
        })));
    })));
}
// src/components/experimental/lodging-compare-table/lodging-compare-table-product-rating.tsx
import React59 from "react";
import { UitkTableCell as UitkTableCell12, UitkTableCellBorder as UitkTableCellBorder12, UitkTableRow as UitkTableRow10 } from "uitk-react-tables";
function LodgingCompareTableProductRating(param) {
    var compareProperties = param.compareProperties;
    return /* @__PURE__ */ React59.createElement(UitkTableRow10, null, compareProperties.map(function(property) {
        var _property_headingSection;
        /* @__PURE__ */ return React59.createElement(UitkTableCell12, {
            border: [
                UitkTableCellBorder12.horizontal,
                UitkTableCellBorder12.vertical
            ],
            key: property.id
        }, ((_property_headingSection = property.headingSection) === null || _property_headingSection === void 0 ? void 0 : _property_headingSection.productRating) && /* @__PURE__ */ React59.createElement(LodgingEGDSRating, {
            data: property.headingSection.productRating
        }));
    }));
}
// src/components/experimental/lodging-compare-table/lodging-compare-table-remove.tsx
import React60 from "react";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { useProvidedState as useProvidedState9 } from "@shared-ui/provided-state-context";
import { UitkTertiaryButton as UitkTertiaryButton3 } from "uitk-react-button";
import { UitkTableCell as UitkTableCell13, UitkTableCellBorder as UitkTableCellBorder13, UitkTableRow as UitkTableRow11 } from "uitk-react-tables";
function LodgingCompareTableRemove(param) {
    var compareProperties = param.compareProperties;
    var _useProvidedState9 = _slicedToArray(useProvidedState9(), 2), dispatch = _useProvidedState9[1];
    var track = useClickTracker6();
    var KEY_REMOVE = "hotels.searchResults.comparison.compare.table.remove";
    var removeText = useFormattedText(KEY_REMOVE, "Remove");
    return /* @__PURE__ */ React60.createElement(UitkTableRow11, null, compareProperties.map(function(property) {
        var handleRemove = function() {
            dispatch({
                type: REMOVE_COMPARE_PROPERTY,
                payload: {
                    propertyId: getCardId(property)
                }
            });
            var rfrr = "HOT.SR.PROPERTY.COMPARISON.property.remove";
            track(getRfrr(rfrr, property), "Property Comparison Property Remove");
        };
        return /* @__PURE__ */ React60.createElement(UitkTableCell13, {
            align: {
                horizontal: "center"
            },
            border: [
                UitkTableCellBorder13.horizontal,
                UitkTableCellBorder13.vertical
            ],
            key: property.id
        }, /* @__PURE__ */ React60.createElement(UitkTertiaryButton3, {
            onClick: handleRemove
        }, removeText));
    }));
}
// src/components/experimental/lodging-compare-table/lodging-compare-table-view.tsx
import React62 from "react";
import { UitkTableRow as UitkTableRow12 } from "uitk-react-tables";
// src/components/experimental/lodging-compare-table/lodging-compare-table-view-cell.tsx
import React61, { useCallback as useCallback8, useContext as useContext3, useMemo as useMemo8 } from "react";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { useProvidedState as useProvidedState10 } from "@shared-ui/provided-state-context";
import { CompareAdaptExContext as CompareAdaptExContext3 } from "@shared-ui/retail-compare-providers";
import { UitkPrimaryButton as UitkPrimaryButton3 } from "uitk-react-button";
import { UitkTableCell as UitkTableCell14, UitkTableCellBorder as UitkTableCellBorder14 } from "uitk-react-tables";
var LodgingCompareTableViewCell = function(param) {
    var property = param.property;
    var KEY_VIEW = "hotels.searchResults.comparison.compare.table.view";
    var text = useFormattedText(KEY_VIEW, "View");
    var _useProvidedState10 = _slicedToArray(useProvidedState10(), 1), state = _useProvidedState10[0];
    var comparePropertyIds = (state[STATE_FIELD_NAME] || defaultState).comparePropertyIds;
    var href = useMemo8(function() {
        var cardLink = property.cardLink;
        if ((cardLink === null || cardLink === void 0 ? void 0 : cardLink.resource.__typename) === "HttpURI") {
            var path = cardLink.useRelativePath ? cardLink.resource.relativePath : cardLink.resource.value;
            return "".concat(path, "&comparePropertyIds=").concat(comparePropertyIds.join(","));
        }
        return null;
    }, [
        property,
        comparePropertyIds
    ]);
    var _useContext3 = _slicedToArray(useContext3(CompareAdaptExContext3), 1), _useContext3_ = _useContext3[0], campaignId = _useContext3_.campaignId, payloadId = _useContext3_.payloadId;
    var track = useClickTracker7();
    var handleClick = useCallback8(function() {
        var rfrr = getRfrr("HOT.HIS.PROPERTY.COMPARISON.view.click", property);
        track(rfrr, "Property Comparison View Click", void 0, campaignId && payloadId ? [
            lightweightAdaptExMicroMessage({
                campaignId: campaignId,
                payloadId: payloadId,
                eventType: "click",
                eventTarget: "compare-button"
            })
        ] : void 0);
    }, [
        property,
        track
    ]);
    return /* @__PURE__ */ React61.createElement(UitkTableCell14, {
        align: {
            horizontal: "center"
        },
        border: [
            UitkTableCellBorder14.horizontal,
            UitkTableCellBorder14.vertical
        ]
    }, href && /* @__PURE__ */ React61.createElement(UitkPrimaryButton3, {
        tag: "a",
        href: href,
        target: "_blank",
        isFullWidth: true,
        onClick: handleClick
    }, text));
};
// src/components/experimental/lodging-compare-table/lodging-compare-table-view.tsx
var LodgingCompareTableView = function(param) {
    var compareProperties = param.compareProperties;
    return /* @__PURE__ */ React62.createElement(UitkTableRow12, null, compareProperties.map(function(property) {
        return /* @__PURE__ */ React62.createElement(LodgingCompareTableViewCell, {
            property: property,
            key: property.id
        });
    }));
};
// src/components/experimental/lodging-compare-table/lodging-compare-table.tsx
var LodgingCompareTable = function() {
    var _useProvidedState11 = _slicedToArray(useProvidedState11(), 1), state = _useProvidedState11[0];
    var _state_STATE_FIELD_NAME;
    var _ref = (_state_STATE_FIELD_NAME = state[STATE_FIELD_NAME]) !== null && _state_STATE_FIELD_NAME !== void 0 ? _state_STATE_FIELD_NAME : defaultState, comparePropertyIds = _ref.comparePropertyIds, searchResultsProperties = _ref.searchResultsProperties;
    var compareProperties = useMemo9(function() {
        return searchResultsProperties.reduce(function(acc, property) {
            var id = property.id;
            var cardId = getCardId(property);
            var indexOfNonAdVersion = acc.findIndex(function(p) {
                return p.id === id;
            });
            if (isAd(property.mediaSection) && indexOfNonAdVersion > -1 && comparePropertyIds.includes(cardId)) {
                acc.splice(indexOfNonAdVersion, 1);
            }
            return comparePropertyIds.includes(cardId) && acc.every(function(param) {
                var propertyId = param.id;
                return propertyId !== cardId;
            }) ? _toConsumableArray(acc).concat([
                property
            ]) : acc;
        }, []);
    }, [
        comparePropertyIds,
        searchResultsProperties
    ]);
    var hasPriceSummary = compareProperties.some(function(property) {
        var _property_priceSection;
        return (_property_priceSection = property.priceSection) === null || _property_priceSection === void 0 ? void 0 : _property_priceSection.priceSummary;
    });
    var hasHeading = compareProperties.some(function(property) {
        var _property_headingSection;
        return (_property_headingSection = property.headingSection) === null || _property_headingSection === void 0 ? void 0 : _property_headingSection.heading;
    });
    var hasProductRating = compareProperties.some(function(property) {
        var _property_headingSection;
        return (_property_headingSection = property.headingSection) === null || _property_headingSection === void 0 ? void 0 : _property_headingSection.productRating;
    });
    var hasMessages = compareProperties.some(function(property) {
        var _property_headingSection, _property_headingSection_messages;
        return (_property_headingSection = property.headingSection) === null || _property_headingSection === void 0 ? void 0 : (_property_headingSection_messages = _property_headingSection.messages) === null || _property_headingSection_messages === void 0 ? void 0 : _property_headingSection_messages.length;
    });
    var hasGuestRating = compareProperties.some(function(property) {
        return property.summarySections.some(function(summary) {
            return summary.guestRating;
        });
    });
    var hasAmenities = compareProperties.some(function(property) {
        var _property_headingSection, _property_headingSection_amenities;
        return (_property_headingSection = property.headingSection) === null || _property_headingSection === void 0 ? void 0 : (_property_headingSection_amenities = _property_headingSection.amenities) === null || _property_headingSection_amenities === void 0 ? void 0 : _property_headingSection_amenities.length;
    });
    var hasFlexSearchDates = compareProperties.some(function(property) {
        return Boolean(property.dateSection);
    });
    return /* @__PURE__ */ React63.createElement(UitkLayoutFlex9, null, /* @__PURE__ */ React63.createElement(UitkLayoutFlexItem7, {
        grow: 1
    }, /* @__PURE__ */ React63.createElement("div", null)), /* @__PURE__ */ React63.createElement(UitkSpacing11, {
        padding: {
            inline: "six"
        }
    }, /* @__PURE__ */ React63.createElement(UitkLayoutFlexItem7, {
        minWidth: "zero"
    }, /* @__PURE__ */ React63.createElement("div", null, /* @__PURE__ */ React63.createElement(UitkTable3, {
        border: true,
        overflow: false
    }, /* @__PURE__ */ React63.createElement(UitkTableBody3, null, /* @__PURE__ */ React63.createElement(LodgingCompareTableMedia, {
        compareProperties: compareProperties
    }), /* @__PURE__ */ React63.createElement(React63.Fragment, null, hasHeading && /* @__PURE__ */ React63.createElement(LodgingCompareTableHeading, {
        compareProperties: compareProperties
    }), hasProductRating && /* @__PURE__ */ React63.createElement(LodgingCompareTableProductRating, {
        compareProperties: compareProperties
    }), hasMessages && /* @__PURE__ */ React63.createElement(LodgingCompareTableMessages, {
        compareProperties: compareProperties
    }), hasGuestRating && /* @__PURE__ */ React63.createElement(LodgingCompareTableGuestRating, {
        compareProperties: compareProperties
    }), hasPriceSummary && /* @__PURE__ */ React63.createElement(LodgingCompareTablePrice, {
        compareProperties: compareProperties
    }), hasFlexSearchDates && /* @__PURE__ */ React63.createElement(LodgingCompareTableFlexSearchDates, {
        compareProperties: compareProperties
    }), hasAmenities && /* @__PURE__ */ React63.createElement(LodgingCompareTableAmenities, {
        compareProperties: compareProperties
    })), /* @__PURE__ */ React63.createElement(LodgingCompareTableView, {
        compareProperties: compareProperties
    }), /* @__PURE__ */ React63.createElement(LodgingCompareTableRemove, {
        compareProperties: compareProperties
    })))))), /* @__PURE__ */ React63.createElement(UitkLayoutFlexItem7, {
        grow: 1
    }, /* @__PURE__ */ React63.createElement("div", null)));
};
// src/components/experimental/lodging-compare-dialog/lodging-compare-dialog.tsx
var LodgingCompareDialog2 = function() {
    var _searchParams_get;
    var DIALOG_TITLE = "hotels.searchResults.comparison.compare.text";
    var DIALOG_TITLE_A11Y = "hotels.searchResults.comparison.compare.text.a11y";
    var title = useFormattedText(DIALOG_TITLE, "Compare");
    var titleA11y = useFormattedText(DIALOG_TITLE_A11Y, "Compare selected properties");
    var triggerRef = React64.useRef();
    var history = useHistory3();
    var location = useLocation2();
    var _useDialog4 = _slicedToArray(useDialog4("lodging-compare-dialog", "compareDialog"), 3), hookIsOpen = _useDialog4[0], DialogActions = _useDialog4[1], DialogComponent = _useDialog4[2];
    var track = useClickTracker8();
    var _useProvidedState12 = _slicedToArray(useProvidedState12(), 2), state = _useProvidedState12[0], dispatch = _useProvidedState12[1];
    var searchParams = React64.useMemo(function() {
        return new URLSearchParams(location.search);
    }, [
        location.search
    ]);
    var _React64_useState = _slicedToArray(React64.useState(Boolean((_searchParams_get = searchParams.get("compareDialog")) === null || _searchParams_get === void 0 ? void 0 : _searchParams_get.length)), 1), wasOpenOnPageLoad = _React64_useState[0];
    var _state_STATE_FIELD_NAME;
    var _ref = (_state_STATE_FIELD_NAME = state[STATE_FIELD_NAME]) !== null && _state_STATE_FIELD_NAME !== void 0 ? _state_STATE_FIELD_NAME : defaultState, stateIsOpen = _ref.isDialogOpen, comparePropertyIds = _ref.comparePropertyIds;
    var isOpen = useRef4(false);
    var referrerUrl = React64.useMemo(function() {
        try {
            return new URL(document.referrer);
        } catch (e) {
            return void 0;
        }
    }, []);
    useEffect5(function() {
        if (stateIsOpen !== isOpen.current) {
            if (stateIsOpen) {
                DialogActions.openDialog();
            } else if (wasOpenOnPageLoad && (referrerUrl === null || referrerUrl === void 0 ? void 0 : referrerUrl.pathname.includes("login"))) {
                searchParams.delete("compareDialog");
                history.replace({
                    pathname: location.pathname,
                    hash: location.hash,
                    state: location.state,
                    search: searchParams.toString()
                });
            } else {
                DialogActions.closeDialog();
            }
            isOpen.current = stateIsOpen;
        } else if (hookIsOpen !== isOpen.current) {
            dispatch({
                type: hookIsOpen ? OPEN_DIALOG : CLOSE_DIALOG
            });
            isOpen.current = hookIsOpen;
        }
    }, [
        stateIsOpen,
        hookIsOpen
    ]);
    useEffect5(function() {
        if (isOpen.current) {
            dispatch({
                type: comparePropertyIds.length === 0 ? CLOSE_DIALOG : OPEN_DIALOG
            });
        }
    }, [
        comparePropertyIds
    ]);
    var closeDialog = useCallback9(function() {
        dispatch({
            type: CLOSE_DIALOG
        });
        track("HOT.SR.PROPERTY.COMPARISON.modal.close", "Property Comparison Modal Close");
        window._qHasUsedPropertyCompare = true;
    }, []);
    return DialogComponent({
        children: /* @__PURE__ */ React64.createElement(UitkSheet4, {
            isVisible: true,
            type: "full",
            triggerRef: triggerRef
        }, /* @__PURE__ */ React64.createElement(UitkToolbar3, {
            toolbarTitle: title,
            navigationContent: {
                onClick: closeDialog,
                navIconLabel: titleA11y
            }
        }), /* @__PURE__ */ React64.createElement(UitkDialogContent2, {
            zeroPadding: true
        }, /* @__PURE__ */ React64.createElement(UitkSpacing12, {
            padding: {
                block: "six"
            }
        }, /* @__PURE__ */ React64.createElement("div", null, /* @__PURE__ */ React64.createElement(LodgingCompareTable, null)))))
    });
};
// src/components/experimental/lodging-compare-sheet/lodging-compare-sheet.tsx
var LodgingCompareSheet = function() {
    var track = useClickTracker9();
    var KEY_ONE_SELECTED = "hotels.searchResults.comparison.selection.text";
    var KEY_MULTIPLE_SELECTED = "hotels.searchResults.comparison.selection.selected.text";
    var KEY_COMPARE_BUTTON = "hotels.searchResults.comparison.compare.text";
    var _useProvidedState13 = _slicedToArray(useProvidedState13(), 2), state = _useProvidedState13[0], dispatch = _useProvidedState13[1];
    var _state_STATE_FIELD_NAME;
    var _ref = (_state_STATE_FIELD_NAME = state[STATE_FIELD_NAME]) !== null && _state_STATE_FIELD_NAME !== void 0 ? _state_STATE_FIELD_NAME : defaultState, comparePropertyIds = _ref.comparePropertyIds, isDialogOpen = _ref.isDialogOpen;
    var triggerRef = React65.useRef();
    var sheetContentRef = React65.useRef();
    var oneSelected = useFormattedText(KEY_ONE_SELECTED, "Select at least 1 more property to compare");
    var uniquePropertyIds = _toConsumableArray(new Set(comparePropertyIds.map(getPropertyIdFromCardId)));
    var multipleSelected = useFormattedText(KEY_MULTIPLE_SELECTED, [
        uniquePropertyIds.length,
        MAX_SELECTABLE
    ], "".concat(uniquePropertyIds.length, "/").concat(MAX_SELECTABLE, " properties selected"));
    var _useContext4 = _slicedToArray(useContext4(CompareAdaptExContext4), 1), enabled = _useContext4[0].enabled;
    var dispatchToastOffset = function(offset) {
        dispatch({
            type: TripsToastStateEvents.SET_OFFSET,
            payload: {
                offset: offset
            }
        });
    };
    var updateToastOffset = function() {
        if (sheetContentRef === null || sheetContentRef === void 0 ? void 0 : sheetContentRef.current) {
            dispatchToastOffset(sheetContentRef.current.clientHeight);
        }
    };
    useEffect6(updateToastOffset, [
        comparePropertyIds
    ]);
    useEffect6(function() {
        if (isDialogOpen) {
            dispatchToastOffset(0);
        } else {
            updateToastOffset();
        }
    }, [
        isDialogOpen
    ]);
    var handleClose = function() {
        track("HOT.SR.PROPERTY.COMPARISON.bottom.close", "Property Comparison Bottom Sheet Close");
        dispatchToastOffset(0);
    };
    var handleOpen = function() {
        track("HOT.SR.PROPERTY.COMPARISON.bottom.open", "Property Comparison Bottom Sheet Open");
    };
    var handleClick = function() {
        track("HOT.SR.PROPERTY.COMPARISON.compare.click", "Property Comparison Compare Click");
        dispatch({
            type: OPEN_DIALOG
        });
    };
    return /* @__PURE__ */ React65.createElement(React65.Fragment, null, /* @__PURE__ */ React65.createElement(UitkSheet5, {
        closeCallback: handleClose,
        openCallback: handleOpen,
        isVisible: enabled && uniquePropertyIds.length > 0,
        liveAnnounceString: "Sheet has opened",
        type: "bottom",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React65.createElement("div", {
        ref: sheetContentRef
    }, /* @__PURE__ */ React65.createElement(UitkSheetContent4, null, /* @__PURE__ */ React65.createElement(UitkLayoutGrid5, {
        alignItems: "center",
        columns: {
            medium: [
                "1fr",
                "min-content"
            ]
        },
        space: {
            row: "four",
            column: "six"
        }
    }, /* @__PURE__ */ React65.createElement(UitkLayoutGridItem5, null, uniquePropertyIds.length > 1 ? /* @__PURE__ */ React65.createElement(UitkText14, {
        size: 400
    }, multipleSelected) : /* @__PURE__ */ React65.createElement(UitkCard2, {
        border: true,
        padded: true
    }, /* @__PURE__ */ React65.createElement(UitkLayoutFlex10, {
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React65.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React65.createElement("div", null, /* @__PURE__ */ React65.createElement(UitkIcon8, {
        name: "info_outline",
        spotlight: "info"
    }))), /* @__PURE__ */ React65.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React65.createElement(UitkText14, null, oneSelected))))), /* @__PURE__ */ React65.createElement(UitkLayoutGridItem5, null, /* @__PURE__ */ React65.createElement(UitkPrimaryButton4, {
        type: "button",
        disabled: uniquePropertyIds.length < 2,
        onClick: handleClick,
        isFullWidth: true,
        size: UitkButtonSize2.LARGE
    }, useFormattedText(KEY_COMPARE_BUTTON, "Compare"))))))), enabled && /* @__PURE__ */ React65.createElement(LodgingCompareDialog2, null));
};
export { CompareSelectionAdaptEx, LodgingCompareSheet, LodgingCompareStateChunk, LodgingCompareStateManager, PropertyCompare }; /* istanbul ignore next -- @preserve */  /* istanbul ignore else -- @preserve */  // istanbul ignore next -- @preserve
//# sourceMappingURL=index.js.map